<template>
    <div :style="{ backgroundColor: memberInfo.is_secret == 1 ? '#15171D' : '', color: memberInfo.is_secret == 1 ? '#fff' : '' }" :class="isPopup ? 'popup_style' : ''" style="display: flex; flex-direction: column; font-weight: 500; position: relative;">
        <!-- <div v-show="isShowBackGroundImage" ref="background_image" class="background_image_wrapper" style="position: fixed; left: 0; top: 0; width: 100%; height: 100%; "></div> -->
        <div v-if="isFriend" style="position: fixed; display: flex; flex-direction: column; left: 0; top: 0; width: 100%; height: 100%; background:#210f0380; z-index: 100;">
            <div :style="{ opacity: isShape1 ? '0' : '1' }" style="transition: all 0.5s; font-weight: 700; font-size: 14px; line-height: 52px; height: 52px; width: 277px; border-radius: 40px; margin: 0 auto; margin-top: 114px; background-color: #fff; text-align: center;">슈팅을 주고 받아서 친구가 됐습니다!🎉</div>
            <template>
                <div style="display: flex; flex-direction: column; align-items: center; position: relative;">
                    <div :style="{ opacity: isShape1 ? '0' : '1' }" style="display: flex; transition: all 0.5s; top: 50%; left: 50%; transform: translate(-50%,-64%); position: absolute; align-items: center; gap: 16px;">
                        <div style="display: flex; flex-direction: column; align-items: center;">
                            <ProfileImage style="width: 100px;" :image-path="myImage"></ProfileImage>
                            <div style="margin-top: 8px; font-weight: 700; line-height: 24px;text-align: center;">{{ $GlobalStore.loginInfo().nic_name + ' ' + ($GlobalStore.loginInfo().position ? $GlobalStore.loginInfo().position : '') }}</div>
                        </div>
                        <div style="display: flex; flex-direction: column; align-items: center;">
                            <ProfileImage style="width: 100px;" :image-path="memberInfo.image_path"></ProfileImage>
                            <div style="margin-top: 8px; font-weight: 700; line-height: 24px;text-align: center;">{{ memberInfo.nic_name + ' ' + (memberInfo.position ? memberInfo.position : '') }}</div>
                        </div>
                    </div>
                    <svg width="100%" height="500" :viewBox="isShape1 ? '0 0 390 528' : '0 0 390 528'" fill="none" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <filter id="filter0_d_36807_2555" x="-38" y="0.878296" width="466" height="526.261" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="5" />
                                <feGaussianBlur stdDeviation="50" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.927708 0 0 0 0 0.744851 0 0 0 1 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_36807_2555" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_36807_2555" result="shape" />
                            </filter>
                            <linearGradient id="paint0_linear_36807_2555" x1="195" y1="387.052" x2="195" y2="131.31" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#FF8F4A" />
                                <stop offset="1" stop-color="#FFAB79" />
                            </linearGradient>
                            <filter id="filter0_d_36807_2554" x="-18" y="0.722534" width="426" height="462.569" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="5" />
                                <feGaussianBlur stdDeviation="25" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.368804 0 0 0 0 0.139279 0 0 0 1 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_36807_2554" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_36807_2554" result="shape" />
                            </filter>
                            <linearGradient id="paint0_linear_36807_2554" x1="195" y1="369.107" x2="195" y2="85.2951" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#FF8F4A" />
                                <stop offset="1" stop-color="#FFAB79" />
                            </linearGradient>
                            <linearGradient id="paint1_linear_36807_2554" x1="195.495" y1="111.001" x2="195.495" y2="344.001" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#210F03" />
                                <stop offset="1" stop-color="#A55119" />
                            </linearGradient>
                        </defs>
                        <g :filter="isShape1 ? 'url(#filter0_d_36807_2555)' : 'url(#filter0_d_36807_2554)'">
                            <path :d="currentPath" :fill="isShape1 ? 'url(#paint0_linear_36807_2555)' : 'url(#paint0_linear_36807_2554)'" />
                            <path :d="currentPathStroke" stroke="#65300D" stroke-width="12" />
                        </g>
                        <path :d="currentPath2" stroke="#FFB787" stroke-width="12" />
                        <path :opacity="isShape1 ? '0' : '0.05'" d="M195.495 111.001C172.454 111.001 149.93 117.834 130.771 130.635C111.613 143.436 96.6808 161.631 87.8632 182.918C79.0456 204.206 76.7385 227.63 81.2337 250.229C85.7289 272.828 96.8244 293.586 113.117 309.879C129.41 326.172 150.168 337.267 172.767 341.763C195.366 346.258 218.79 343.951 240.078 335.133C261.365 326.315 279.56 311.383 292.361 292.225C305.163 273.067 311.995 250.543 311.995 227.501C311.963 196.613 299.678 167 277.837 145.159C255.996 123.318 226.383 111.034 195.495 111.001ZM204.457 155.114L232.226 136.015C248.126 142.419 262.091 152.841 272.755 166.26L263.793 196.438C263.569 196.438 263.334 196.55 263.11 196.629L237.547 204.929C237.164 205.053 236.79 205.203 236.427 205.377L204.457 183.388V155.114ZM158.798 136.015L186.534 155.114V183.388L154.541 205.422C154.178 205.248 153.804 205.098 153.421 204.974L127.858 196.673C127.634 196.595 127.399 196.539 127.175 196.483L118.213 166.305C128.887 152.861 142.873 142.423 158.798 136.015ZM144.235 280.621H112.489C103.196 266.172 97.8686 249.533 97.0415 232.374L121.686 213.465C121.898 213.558 122.115 213.641 122.335 213.712L147.909 222.023C148.251 222.126 148.599 222.208 148.951 222.27L161.038 257.466C160.87 257.668 160.702 257.869 160.545 258.082L144.75 279.825C144.565 280.081 144.393 280.347 144.235 280.621ZM220.912 322.717C204.258 327.153 186.732 327.153 170.078 322.717L158.809 290.904C158.954 290.725 159.111 290.557 159.246 290.366L175.052 268.612C175.237 268.36 175.409 268.098 175.567 267.828H215.423C215.581 268.098 215.753 268.36 215.939 268.612L231.745 290.366C231.879 290.557 232.036 290.725 232.181 290.904L220.912 322.717ZM246.755 280.587C246.598 280.313 246.426 280.047 246.24 279.792L230.434 258.082C230.277 257.869 230.109 257.668 229.941 257.466L242.028 222.27C242.38 222.208 242.728 222.126 243.07 222.023L268.644 213.712C268.864 213.641 269.081 213.558 269.293 213.465L293.938 232.374C293.11 249.533 287.783 266.172 278.49 280.621L246.755 280.587Z" fill="url(#paint1_linear_36807_2554)" />
                    </svg>
                    <div :style="{ opacity: isShape1 ? '0' : '1' }" @click="closeFriendPopup" style="transition: all 0.5s; width: 266px; margin: 0 auto; margin-top: -90px; height: 60px; text-align: center; line-height: 60px; background-color: #fff; border-radius: 40px; font-size: 14px; font-weight: 700;">확인</div>
                </div>
            </template>
        </div>
        <div v-if="mode === MY_VIEW_MODE.ME && !isPopup" style="margin-top: 14px; margin-bottom: 12px; padding: 0 12px; position: relative;">
            <div style="text-align: center; font-weight: 700; line-height: 24px;">마이페이지</div>
            <div style="display: flex; align-items: center; gap: 20px; position: absolute; right: 14px; top: 0">
                <div @click="showSettings(); $Util.sendEventClick('마이페이지_환경설정')" style="">
                    <img v-if="!isSecretProfile" style="width: 20px;" :src="require('@/assets/img/join_setting.png')" alt="">
                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.2561 12C21.2561 11.724 21.2438 11.46 21.2191 11.184L23.5146 9.492C24.0083 9.132 24.144 8.46 23.8355 7.932L21.5276 4.056C21.3797 3.80182 21.1403 3.60977 20.8556 3.51674C20.5708 3.42372 20.2607 3.43627 19.9849 3.552L17.3315 4.644C16.8749 4.332 16.3936 4.056 15.8876 3.828L15.5297 1.056C15.4556 0.456 14.9249 0 14.3079 0H9.70448C9.07507 0 8.54438 0.456 8.47033 1.056L8.11243 3.828C7.60643 4.056 7.12511 4.332 6.66848 4.644L4.01505 3.552C3.44735 3.312 2.78091 3.528 2.47237 4.056L0.16451 7.944C-0.144028 8.472 -0.00827135 9.132 0.485388 9.504L2.78091 11.196C2.72944 11.7348 2.72944 12.2772 2.78091 12.816L0.485388 14.508C-0.00827135 14.868 -0.144028 15.54 0.16451 16.068L2.47237 19.944C2.78091 20.472 3.44735 20.688 4.01505 20.448L6.66848 19.356C7.12511 19.668 7.60643 19.944 8.11243 20.172L8.47033 22.944C8.54438 23.544 9.07507 24 9.69214 24H14.2955C14.9126 24 15.4433 23.544 15.5173 22.944L15.8752 20.172C16.3812 19.944 16.8625 19.668 17.3192 19.356L19.9726 20.448C20.5403 20.688 21.2067 20.472 21.5153 19.944L23.8231 16.068C24.1317 15.54 23.9959 14.88 23.5023 14.508L21.2067 12.816C21.2438 12.54 21.2561 12.276 21.2561 12ZM12.0494 16.2C9.66746 16.2 7.72984 14.316 7.72984 12C7.72984 9.684 9.66746 7.8 12.0494 7.8C14.4313 7.8 16.3689 9.684 16.3689 12C16.3689 14.316 14.4313 16.2 12.0494 16.2Z" fill="white"/>
                    </svg>
                </div>
                <div @click="showMenu">
                    <img v-if="!isSecretProfile" style="width: 22px;" :src="require('@/assets/img/hamburger_menu.png')" alt="">
                    <svg v-else width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.1458 16.9167C21.6113 16.9169 22.0588 17.0962 22.3957 17.4174C22.7326 17.7386 22.933 18.1771 22.9553 18.6421C22.9777 19.107 22.8204 19.5627 22.5159 19.9148C22.2114 20.2669 21.7831 20.4883 21.3198 20.5332L21.1458 20.5417H1.8125C1.34703 20.5414 0.89949 20.3621 0.562616 20.0409C0.225743 19.7197 0.0253605 19.2812 0.00299152 18.8163C-0.0193774 18.3513 0.137982 17.8956 0.442462 17.5435C0.746942 17.1915 1.1752 16.97 1.6385 16.9251L1.8125 16.9167H21.1458ZM21.1458 8.45833C21.6265 8.45833 22.0876 8.64929 22.4275 8.9892C22.7674 9.32911 22.9583 9.79013 22.9583 10.2708C22.9583 10.7515 22.7674 11.2126 22.4275 11.5525C22.0876 11.8924 21.6265 12.0833 21.1458 12.0833H1.8125C1.3318 12.0833 0.870779 11.8924 0.530869 11.5525C0.190959 11.2126 0 10.7515 0 10.2708C0 9.79013 0.190959 9.32911 0.530869 8.9892C0.870779 8.64929 1.3318 8.45833 1.8125 8.45833H21.1458ZM21.1458 0C21.6265 0 22.0876 0.190959 22.4275 0.530869C22.7674 0.870779 22.9583 1.33179 22.9583 1.8125C22.9583 2.2932 22.7674 2.75422 22.4275 3.09413C22.0876 3.43404 21.6265 3.625 21.1458 3.625H1.8125C1.3318 3.625 0.870779 3.43404 0.530869 3.09413C0.190959 2.75422 0 2.2932 0 1.8125C0 1.33179 0.190959 0.870779 0.530869 0.530869C0.870779 0.190959 1.3318 0 1.8125 0H21.1458Z" fill="white"/>
                    </svg>
                </div>
            </div>
        </div>
        <div v-else>
            <MercenaryHeader :isBlur="true" :back-title="'뒤로가기'" :close-action="beforeCloseAction"></MercenaryHeader>
        </div>
        <div style="flex: 1; overflow-y: hidden; ">
            <InfinityScroll style="height: 100%;" :handleNextPage="handleNextPage" :isEnableNextPageHandle="isEnableNextPageHandle">
                <div :style="{ opacity: showContents ? '1' : '0' }" v-if="isComplete">
                    <div style="margin-bottom: 20px;">
                        <div style="padding: 0 12px;">
                            <div
                                v-if="mode === MY_VIEW_MODE.ME && !isCoach"
                                style="display: flex; justify-content: center; margin-bottom: 18px;"
                            >
                                <div
                                    class="secret_toggle"
                                    :class="{ is_secret: isSecretProfile }"
                                    @click="showSecretToggleAlert"
                                >
                                    <span class="secret_toggle_label">{{ isSecretProfile ? '시크릿' : '공개' }}</span>
                                    <span class="secret_toggle_knob"></span>
                                </div>
                            </div>
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <div style="display: flex; align-items: center; gap: 9px">
                                    <ProfileImage style="width: 70px;" :is-show-border="false" :imagePath="memberInfo.image_path"></ProfileImage>
                                    <div>
                                        <div style="font-weight: 700;">{{ isCoach ? memberInfo.name : memberInfo.nic_name }}
                                            <!-- <span v-if="!isCoach" style="font-weight: 900; font-size: 19px;">
                                                <DivisionPositionText :position="memberInfo.position" :positionProAbility="memberInfo.position_pro_ability"></DivisionPositionText>
                                            </span>
                                            <template v-else>
                                                <img v-if="teamInfo && teamInfo.type === TEAM_TYPE.CLASS_1_PRO_TEAM" :src="require('@/assets/img/blue_star.png')" style="margin-left:3px; width:16px; height:16px;">
                                                <img v-else :src="require('@/assets/img/yellow_star.png')" style="margin-left:3px; width:16px; height:16px;">
                                            </template> -->
                                        </div>
                                        <div v-if="!isSecretProfile || mode == MY_VIEW_MODE.ME" style=" font-size: 12px; line-height: 24px; color: #606060;">{{ memberInfo.name }} {{ '#' + transRecommendCode }}</div>
                                        <!-- <template v-if="teamInfo && teamInfo.is_deleted == 0">
                                            <div style="display: flex; align-items: center; gap: 8px;">
                                                <div style="font-weight: 500; line-height: 24px; color: #6ca7ff;" @click="showTeamDetail(teamInfo.idx)">{{ teamInfo ? teamInfo.name : '' }}</div>
                                                <div style="width: 2px; height: 16px; background-color: #d9d9d9;"></div>
                                                <div style="font-size: 14px; font-weight: 500; color: #808080;">월간 조회수 {{ month_period_view_cnt }}회</div>
                                            </div>
                                        </template> -->
                                    </div>
                                </div>
                                <!-- <div style="" v-if="!isCoach">
                                    <div :style="{ background: setBackgroundColor(myGradeName) }" @click="showPositionResult" style="min-width: 82px; min-height: 92px; border-radius: 6px; display: flex;">
                                        <div style="padding: 6px; flex: 1; display: flex; flex-direction: column;">
                                            <div v-if="memberInfo.position !== '' && memberInfo.position">
                                                <div :class="setPositionClass(myGradeName)" style="font-size: 12px; font-weight: 900; color: #fff; display: inline-block; border-radius: 4px; padding: 2px 4px;">{{ memberInfo.position }}</div>
                                            </div>
                                            <div style="margin-top: 3px; flex: 1; display: flex; align-items: center; justify-content: center;">
                                                <img :style="{ width: myGradeName === GRADE_NAME.BALL_BOY || myGradeName === GRADE_NAME.ACE ? '28px' : '23px' }" :src="$resourcePath + myGradeImagePath" alt="">
                                            </div>
                                            <div v-html="myGradeName" style="margin-top: 4px; text-align: center; line-height: 14px; font-weight: 900; font-size: 12px; color: #fff;"></div>
                                        </div>
                                    </div>
                                </div> -->
                                <div v-if="memberInfo.position !== '' && memberInfo.position && !isCoach">
                                    <div :style="{ background: memberInfo.position_pro_ability ? 'linear-gradient(180deg, #1370AF 0%, #210F03 31.66%)' : 'linear-gradient(180deg, #FFDFCA 0%, #FDAE7B 100%)' }" @click="showPositionResult" style="width: 70px; height: 80px; border-radius: 6px; display: flex; justify-content: center; align-items: center; flex-direction: column;">
                                        <img style="width: 32px;" :src="require('@/assets/img/position_white.png')" alt="">
                                        <div style="margin-top: 4px; font-size: 14px; font-weight: 900; color: #fff;">{{ memberInfo.position }}</div>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top: 15px;">
                                <template v-if="!isCoach">
                                    <div style="display: flex; justify-content: space-around;">
                                        <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                                            <div style="font-weight: 900; font-size: 20px; line-height: 24px;">{{ training_cnt }}</div>
                                            <div style="font-weight: 500; line-height: 24px; font-size: 12px;">훈련 수</div>
                                        </div>
                                            <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                                            <div style="font-weight: 900; font-size: 20px; line-height: 24px;">{{ scout_cnt }}</div>
                                            <div style="font-weight: 500; line-height: 24px; font-size: 12px;">스카웃 수</div>
                                        </div>
                                        <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                                            <div style="font-weight: 900; font-size: 20px; line-height: 24px;">{{ total_view_cnt }}</div>
                                            <div style="font-weight: 500; line-height: 24px; font-size: 12px;">총 조회수</div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div style="display: flex; justify-content: space-around;">
                                        <div style="display: flex; flex-direction: column; align-items: center;">
                                            <div style="font-weight: 500; font-size: 12px; line-height: 18px;">관심 선수</div>
                                            <div style="font-weight: 700; line-height: 18px; font-size: 12px;">{{ favorite_member_cnt }}명</div>
                                        </div>
                                        <div style="display: flex; flex-direction: column; align-items: center;">
                                            <div style="font-weight: 500; font-size: 12px; line-height: 18px;">서포터즈</div>
                                            <div style="font-weight: 700; line-height: 18px; font-size: 12px;">{{ teamInfo ? teamInfo.like_cnt : 0 }}명</div>
                                        </div>
                                        <div style="display: flex; flex-direction: column; align-items: center;">
                                            <div style="font-weight: 500; font-size: 12px; line-height: 18px;">총 조회수</div>
                                            <div style="font-weight: 700; line-height: 18px; font-size: 12px;">{{ total_view_cnt }}회</div>
                                        </div>
                                    </div>
                                </template>
                                <!-- <div style="font-size: 14px; font-weight: 500; color: #808080;">월간 조회수 {{ month_period_view_cnt }}회</div> -->
                            </div>
                            <div style="margin-top: 20px;" v-if="mode === MY_VIEW_MODE.ME && !isMeCoach && false">
                                <!-- <div @click="showRewardPage" style="background: linear-gradient(90deg, #FBA324 0%, #FDE18E 100%); border-radius: 12px; display: flex; align-items: center; height: 60px; padding: 12px; gap: 8px;">
                                    <div>
                                        <img style="width: 30px;" :src="require('@/assets/img/reward_star.png')" alt="">
                                    </div>
                                    <div style="font-size: 12px; font-weight: 700;"><span style="font-weight: 700; font-size: 20px;">{{ memberInfo.point }}p</span> / 오늘 획득 포인트{{ memberInfo.today_point ? memberInfo.today_point : 0 }} p</div>
                                </div> -->
                                <div @click="showGrowthReport" class="gradient_border" style="">
                                    <div style="display: flex; justify-content: space-between;">
                                        <div style="display: flex; align-items: center; gap: 4px;">
                                            <img style="width: 17px;" :src="require('@/assets/img/weekly_wage.png')" alt="">
                                            <div style="font-weight: 500; font-size: 12px;">나의 주급(포인트)</div>
                                        </div>
                                        <div style="font-weight: 700; font-size: 20px;">{{ memberInfo.point }} P</div>
                                    </div>
                                    <div style="margin-top: 7px; background-color: #d9d9d9; height: 7px; border-radius: 12px;">
                                        <div :style="{width: remainPercent + '%'}" style="border-radius: 12px; background-color: var(--color-main); height: 100%;"></div>
                                    </div>
                                    <div style="font-weight: 500; font-size: 12px; line-height: 16px; margin-top: 5px; text-align: right; color: #606060;">
                                        <span style="font-weight: 700; color: var(--color-main);">{{ nextPlayer }} 선수</span>까지 {{ remainPoint }}P 남음
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top: 20px;" v-else-if="mode === MY_VIEW_MODE.ME && isMeCoach && false">
                                <div class="gradient_border">
                                    <div style="display: flex; align-items: center; flex: 1; justify-content: space-between;">
                                        <div style="display: flex; gap: 9px;  align-items: center;">
                                            <div>
                                                <img style="width: 42px;" :src="require('@/assets/img/weekly_wage.png')" alt="">
                                            </div>
                                            <div>
                                                <div style="font-size: 12px; font-weight: 500;">사용 가능 포인트</div>
                                                <div style="font-weight: 700; font-size: 20px; margin-top: 8px;">241 P</div>
                                            </div>
                                        </div>
                                        <div style="color: #fff; background-color: #210f03; border-radius: 12px; width: 82px; height: 35px; text-align: center; line-height: 35px; font-weight: 500; font-size: 12px;">+ 충전하기</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="false" style="margin-top: 20px;">
                                <MyCurrentScout :memberInfo="memberInfo"></MyCurrentScout>
                            </div>
                        </div>
                        <div style="line-height: 24px; margin-top: 20px; font-size: 14px; font-weight: 500; text-align: center; padding: 0 12px;">{{ memberInfo.introduce }}</div>
                        <div v-if="mode === MY_VIEW_MODE.ME" style="margin-top: 20px; padding: 0 12px; border-bottom: 1px solid #f5f5f5; padding-bottom: 20px;">
                            <div @click="showProfileEdit(); $Util.sendEventClick('마이페이지_프로필수정')" :style="{ backgroundColor: memberInfo.is_secret == 1 ? '#080808' : '#f5f5f5', border: memberInfo.is_secret == 1 ? '1px solid #e2e2e2' : '' }" class="lite_background_btn" v-if="mode === MY_VIEW_MODE.ME" style="margin: 0 auto; ">프로필 수정</div>
                        </div>
                    </div>

                    <div>
                        <div style="">
                            <div v-if="!isCoach" style="display: flex; gap: 16px; margin-bottom: 16px; padding: 0 12px; border-bottom: 1px solid #f5f5f5; padding-bottom: 16px;">
                                <div @click="showActiveRank" style="flex-basis: 50%; border-radius: 12px; border: 2px solid #f1f2f5;">
                                    <PedometerSimple :isSecret="memberInfo.is_secret" :mode="mode" :memberInfo="memberInfo"></PedometerSimple>
                                </div>
                                <div style="flex-basis: 50%; min-height: 147px; max-height: 147px; border: 2px solid #f1f2f5; border-radius: 12px; padding: 12px 8px; display: flex; justify-content: space-between; flex-direction: column;">
                                    <div style="font-size: 12px; font-weight: 700; white-space: nowrap;">이번 주는 총 <span :style="{ color: memberInfo.is_secret == 1 ? '#9E4CF6' : 'var(--color-main)' }">{{ trainingDate.reduce((sum, item) => sum + (item.count || 0), 0) }} 회</span> 훈련했습니다</div>
                                    <div>
                                        <div style="display: flex; position: relative; justify-content: space-around;">
                                            <div style="height: 1px; width: 100%; background-color: #bbbbbb; bottom: 17px; position: absolute;"></div>
                                            <div v-for="each, i in trainingDate" :key="i + 'training'" style="display: flex; flex-direction: column; align-items: center; gap: 6px;">
                                                <div style="display: flex; flex-direction: column; gap: 4px; align-items: center; flex: 1; justify-content: flex-end;">
                                                    <div style="font-size: 10px; font-weight: 500;">{{ each.count > 0 ? each.count : '' }}</div>
                                                    <div :style="{ height: each.count * 10 + 'px', backgroundColor: memberInfo.is_secret == 1 ? '#9E4CF6' : 'var(--color-main)' }" style="width: 16px; max-height: 80px; border-top-left-radius: 4px; border-top-right-radius: 4px;"></div>
                                                </div>
                                                <div style="font-size: 12px; font-weight: 500; color: #bbbbbb;">{{ each.day }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else style="margin-bottom: 20px; display: flex; gap: 12px; padding: 0 12px;">
                                <div @click="showActiveRank" style="flex-basis: 50%; border-radius: 12px; border: 2px solid #f1f2f5;">
                                    <PedometerSimple :mode="mode" :memberInfo="memberInfo"></PedometerSimple>
                                </div>
                                <div v-if="memberInfo.coach_type === '감독'" style="flex-basis: 50%; display: flex; justify-content: center; align-items: center; border-radius: 12px; border: 2px solid #f1f2f5;">
                                    <div @click="showNotExpert" v-if="!teamInfo" style="display: flex; align-items: center; overflow: hidden;">
                                        <div style="color: #808080; font-weight: 700; font-size: 14px;">팀 미등록 상태</div>
                                        <div style="">
                                            <img style="width: 67px;" :src="require('@/assets/img/no_team.png')" alt="">
                                        </div>
                                    </div>
                                    <div @click="showTeamDetail(teamInfo.idx)" v-else-if="teamInfo && mode === MY_VIEW_MODE.OTHER" style="text-align: center;">
                                        <div style="height: 61px;">
                                            <img style="width: 66px; height: 100%; object-fit: cover;" :src="$resourcePath + teamInfo.image_path" alt="">
                                        </div>
                                        <div style="font-weight: 700; color: #6ca7ff; line-height: 24px;">{{ teamInfo.name }}</div>
                                        <div style="font-weight: 500; font-size: 12px; line-height: 24px; color: #808080;">월간 조회수 {{ teamInfo.view_cnt }}회</div>
                                    </div>
                                    <div @click="showMyReport" v-else-if="teamInfo && mode === MY_VIEW_MODE.ME" style="display: flex; align-items: center; overflow: hidden;">
                                        <div style="padding-left: 10px; font-weight: 700; position: relative;">
                                            <div style="white-space: nowrap; position: relative; z-index: 1; font-size: 14px;">스카우팅 리포트</div>
                                            <div style="position: absolute; top: 50%; left: 57%; opacity: 0.4; z-index: 0; transform: translate(-50%, -50%);">
                                                <img style="width: 79px;" :src="$resourcePath + teamInfo.image_path" alt="">
                                            </div>
                                        </div>
                                        <div style="">
                                            <img style="width: 67px;" :src="require('@/assets/img/scout_report.png')" alt="">
                                        </div>
                                    </div>
                                </div>
                                <div v-else style="flex-basis: 50%; display: flex; justify-content: center; align-items: center; border-radius: 12px; border: 2px solid #f1f2f5;">
                                    <div @click="showNotExpertCoach" v-if="mode === MY_VIEW_MODE.ME" style="display: flex; align-items: center; justify-content: space-around; overflow: hidden;">
                                        <div style="padding-left: 4px;">
                                            <img style="width: 78px;" :src="require('@/assets/img/coaching_main.png')" alt="">
                                        </div>
                                        <div v-if="memberInfo.is_coach == 0 || !coachHistory || coachHistory.state == MEMBER_CAREER_HISTORY_STATE.REQUEST" style="color: #808080; font-weight: 700; font-size: 14px; padding-right: 6px">코치 경력 입력</div>
                                        <div v-else style="color: #808080; font-weight: 700; font-size: 14px; padding-right: 6px">코칭 리포트</div>
                                    </div>
                                    <div @click="showCoachHistory" v-else style="display: flex; align-items: center; justify-content: space-around; overflow: hidden;">
                                        <div style="padding-left: 4px;">
                                            <img style="width: 78px;" :src="require('@/assets/img/coaching_main.png')" alt="">
                                        </div>
                                        <div style="color: #808080; font-weight: 700; font-size: 14px; padding-right: 6px;">코치 경력 보기</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!isCoach" class="need_grid" style="padding: 0 12px; border-bottom: 1px solid #f5f5f5; padding-bottom: 16px;">
                                <InteractionOfScale v-if="(memberInfo.age_range && memberInfo.age_range_show == 1) || (memberInfo.sex && memberInfo.sex_show == 1)" :scaleNumber="'0.97'">
                                    <div @click="setIsAgeOrSex(isAgeOrSex); $Util.sendEventClick('마이페이지_나이_및_성별설정')" style="" :class="isCoach ? 'profile_box_coach' : 'profile_box'">
                                        <div v-if="(memberInfo.age_range && memberInfo.age_range_show == 1) && (memberInfo.sex && memberInfo.sex_show == 1)" style="display: flex; gap: 6px; position: absolute;">
                                            <div :style="{ backgroundColor: isAgeOrSex === PROFILE_BOX_LIST.AGE_RANGE ? '#5c9dff' : '#BBBBBB' }" style="width: 4px; height: 4px; border-radius: 50%;"></div>
                                            <div :style="{ backgroundColor: isAgeOrSex === PROFILE_BOX_LIST.SEX ? '#5c9dff' : '#BBBBBB' }" style="width: 4px; height: 4px; border-radius: 50%;"></div>
                                        </div>
                                        <div style="padding-top: 10px;">
                                            <div v-show="memberInfo.age_range && isAgeOrSex === PROFILE_BOX_LIST.AGE_RANGE && memberInfo.age_range_show == 1" :class="['inner_circle', { inner_circle_secret: isSecretProfile }]">
                                                <img style="width: 20px" :src="require(`@/assets/images/mypage/profile_box_age_range.svg`)" />
                                            </div>
                                            <div v-show="memberInfo.sex && isAgeOrSex === PROFILE_BOX_LIST.SEX && memberInfo.sex_show == 1" :class="['inner_circle', { inner_circle_secret: isSecretProfile }]"> 
                                                <img style="width: 20px" :src="require(`@/assets/images/mypage/profile_box_sex.svg`)" />
                                            </div>
                                        </div>
                                        <div v-show="memberInfo.age_range && isAgeOrSex === PROFILE_BOX_LIST.AGE_RANGE && memberInfo.age_range_show == 1" style="font-size: 12px; font-weight: 700; text-align: center; line-height: 16px;">{{ memberInfo.age_range }}</div>
                                        <div v-show="memberInfo.sex && isAgeOrSex === PROFILE_BOX_LIST.SEX && memberInfo.sex_show == 1" style="font-size: 12px; font-weight: 700; text-align: center; line-height: 16px;">{{ memberInfo.sex }}성</div>
                                    </div>
                                </InteractionOfScale>
                                <InteractionOfScale :scaleNumber="'0.97'" v-if="memberInfo.height || memberInfo.foot_way">
                                    <div @click="setIsHeightOrFootWay(isHeightOrFootWay); $Util.sendEventClick('마이페이지_키_및_주로쓰는발설정')" style="" :class="isCoach ? 'profile_box_coach' : 'profile_box'">
                                        <div v-if="memberInfo.height && memberInfo.foot_way" style="display: flex; gap: 6px; position: absolute;">
                                            <div :style="{ backgroundColor: isHeightOrFootWay === PROFILE_BOX_LIST.HEIGHT ? '#5c9dff' : '#bbbbbb' }" style="width: 4px; height: 4px; border-radius: 50%; background-color: #5c9dff;"></div>
                                            <div :style="{ backgroundColor: isHeightOrFootWay === PROFILE_BOX_LIST.FOOT_WAY ? '#5c9dff' : '#bbbbbb' }" style="width: 4px; height: 4px; border-radius: 50%; background-color: #5c9dff;"></div>
                                        </div>
                                        <div style="padding-top: 10px;">
                                            <div v-show="memberInfo.height && isHeightOrFootWay === PROFILE_BOX_LIST.HEIGHT" :class="['inner_circle', { inner_circle_secret: isSecretProfile }]">
                                                <img style="pointer-events: none; width: 20px;" :src="require(`@/assets/images/mypage/profile_box_height.svg`)">
                                            </div>
                                            <div v-show="memberInfo.foot_way && isHeightOrFootWay === PROFILE_BOX_LIST.FOOT_WAY" :class="['inner_circle', { inner_circle_secret: isSecretProfile }]">
                                                <img style="pointer-events: none; width: 20px;" :src="getFootImage(memberInfo.foot_way)">
                                            </div>
                                        </div>
                                        <div v-show="memberInfo.height && isHeightOrFootWay === PROFILE_BOX_LIST.HEIGHT" style="font-size: 12px; font-weight: 700; text-align: center; line-height: 16px;">{{ transText(PROFILE_BOX_LIST.HEIGHT) }}</div>
                                        <div v-show="memberInfo.foot_way && isHeightOrFootWay === PROFILE_BOX_LIST.FOOT_WAY" style="font-size: 12px; font-weight: 700; text-align: center; line-height: 16px;">{{ transText(PROFILE_BOX_LIST.FOOT_WAY) }}</div>
                                    </div>
                                </InteractionOfScale>
                                <div @click="test(each)" style="" v-for="each, i in profileBoxList" :key="i">
                                    <InteractionOfScale :scaleNumber="'0.97'" :class="isCoach ? 'profile_box_coach' : 'profile_box'">
                                        <template v-if="each === PROFILE_BOX_LIST.SPECIAL_SKILL && multipleBox[0].length > 1">
                                            <div style="display: flex; gap: 6px; position: absolute;">
                                                <div v-for="each, i in multipleBox[0]" :key="i + 'special_skill'" :style="{ backgroundColor: i === specialSkillIndex ? '#5c9dff' : '#bbbbbb' }" style="width: 4px; height: 4px; border-radius: 50%; background-color: #5c9dff;"></div>
                                            </div>
                                        </template>
                                        <template v-if="each === PROFILE_BOX_LIST.USE_REASONS && multipleBox[1].length > 1">
                                            <div style="display: flex; gap: 6px; position: absolute;">
                                                <div v-for="each, i in multipleBox[1]" :key="i + 'use_reasons'" :style="{ backgroundColor: i === useReasonsIndex ? '#5c9dff' : '#bbbbbb' }" style="width: 4px; height: 4px; border-radius: 50%; background-color: #5c9dff;"></div>
                                            </div>
                                        </template>
                                        <template v-if="each === PROFILE_BOX_LIST.PLAY_STYLE && multipleBox[2].length > 1">
                                            <div style="display: flex; gap: 6px; position: absolute;">
                                                <div v-for="each, i in multipleBox[2]" :key="i + 'play_style'" :style="{ backgroundColor: i === playStyleIndex ? '#5c9dff' : '#bbbbbb' }" style="width: 4px; height: 4px; border-radius: 50%; background-color: #5c9dff;"></div>
                                            </div>
                                        </template>
                                        <div style="padding-top: 10px;">
                                            <div :class="['inner_circle', { inner_circle_secret: isSecretProfile }]">
                                                <object style="pointer-events: none; width: 20px;" :data="require(`@/assets/images/mypage/profile_box_${each}.svg`)" type=""></object>
                                            </div>
                                        </div>
                                        <div ref="text_wrap" style="font-size: 12px; width: 70px; font-weight: 700; overflow: hidden; text-align: center;">
                                            <span ref="text" style="display: inline-block; transform: translateX(0); line-height: 16px;">{{ transText(each, specialSkillIndex, useReasonsIndex, playStyleIndex) }}</span>
                                        </div>
                                    </InteractionOfScale>
                                </div>
                            </div>
                            <div v-else :class="profileBoxList.length === 1 ? 'no_grid' : 'need_grid_coach'" style="padding: 0 12px; border-bottom: 1px solid #f5f5f5; padding-bottom: 12px;">
                                <div @click="showPositionProResult(each)" v-for="each, i in profileBoxList" :key="i + 'profileBoxCoach'">
                                    <InteractionOfScale scaleNumber="0.97" style="" :class="[each === PROFILE_BOX_LIST.POSITION ? isPositionBox : '', isCoach ? 'profile_box_coach' : 'profile_box']">
                                        <div class="inner_circle_coach" style="position: relative">
                                            <img style="width: 20px;" v-if="each !== PROFILE_BOX_LIST.POSITION" :src="require(`@/assets/images/mypage/profile_box_coach_${each}.svg`)">
                                            <span v-else>
                                                <img style="width: 20px;" v-if="memberInfo.position_pro_ability" :src="require('@/assets/images/mypage/profile_position_pro.svg')">
                                                <img style="width: 20px;" v-else :src="require('@/assets/images/mypage/profile_box_position.svg')">
                                            </span>
                                        </div>
                                        <div style="font-size: 12px; font-weight: 700; text-align: center; line-height: 16px;">{{ transTextCoach(each) }}</div>
                                    </InteractionOfScale>
                                </div>
                                <InteractionOfScale scaleNumber="0.97" v-if="(memberInfo.age_range && memberInfo.age_range_show == 1) || (memberInfo.sex && memberInfo.sex_show == 1)">
                                    <div @click="setIsAgeOrSex(isAgeOrSex); $Util.sendEventClick('마이페이지_나이_및_성별설정')" style="" :class="isCoach ? 'profile_box_coach' : 'profile_box'">
                                        <div v-if="(memberInfo.age_range && memberInfo.age_range_show == 1) && (memberInfo.sex && memberInfo.sex_show == 1)" style="display: flex; top: -13px; gap: 6px; position: absolute;">
                                            <div :style="{ backgroundColor: isAgeOrSex === PROFILE_BOX_LIST.AGE_RANGE ? '#5c9dff' : '#BBBBBB' }" style="width: 6px; height: 6px; border-radius: 50%;"></div>
                                            <div :style="{ backgroundColor: isAgeOrSex === PROFILE_BOX_LIST.SEX ? '#5c9dff' : '#BBBBBB' }" style="width: 6px; height: 6px; border-radius: 50%;"></div>
                                        </div>
                                        <div style="">
                                            <div v-show="memberInfo.age_range && isAgeOrSex === PROFILE_BOX_LIST.AGE_RANGE && memberInfo.age_range_show == 1" class="inner_circle_coach">
                                                <img style="width: 20px;" :src="require(`@/assets/images/mypage/profile_box_age_range.svg`)" />
                                            </div>
                                            <div v-show="memberInfo.sex && isAgeOrSex === PROFILE_BOX_LIST.SEX && memberInfo.sex_show == 1" class="inner_circle_coach">
                                                <img style="width: 20px;" :src="require(`@/assets/images/mypage/profile_box_sex.svg`)" />
                                            </div>
                                        </div>
                                        <div v-show="memberInfo.age_range && isAgeOrSex === PROFILE_BOX_LIST.AGE_RANGE && memberInfo.age_range_show == 1" style="font-size: 12px; font-weight: 700; text-align: center; line-height: 16px;">{{ memberInfo.age_range }}</div>
                                        <div v-show="memberInfo.sex && isAgeOrSex === PROFILE_BOX_LIST.SEX && memberInfo.sex_show == 1" style="font-size: 12px; font-weight: 700; text-align: center; line-height: 16px;">{{ memberInfo.sex }}성</div>
                                    </div>
                                </InteractionOfScale>
                            </div>
                        </div>
                        <div style="margin-top: 20px;" v-if="mode === MY_VIEW_MODE.ME && !isCompleteProfileBox && !isCoach">
                            <div style="display: flex; align-items: center; gap: 4px; justify-content: center;">
                                <img v-if="!isSecretProfile" style="width: 12px;" :src="require('@/assets/images/mypage/profile_box_icon.png')" alt="">
                                <img v-else style="width: 12px;" :src="require('@/assets/images/mypage/profile_box_icon_white.png')" alt="">
                                <div style="font-weight: 700; font-size: 14px;">프로필 박스를 완성해주세요</div>
                            </div>
                            <div style="font-size: 12px;text-align: center; line-height: 20px;"> {{ completeCount }}/8개 완료</div>
                            <div class="hide_scroll" style="display: flex; gap: 12px; overflow-x: scroll; padding: 0 12px; margin-top: 8px;">
                                <div :style="{ display: each.isComplete ? 'none' : 'block' }" @click="setIsOpenSettings(each.name, false, each.isComplete); $Util.sendEventClick(`마이페이지_설정하기_${each.name}`)" v-for="each, i in myProfileBoxList" :key="i">
                                    <div v-if="!each.isComplete" style="color: #210f03" class="my_profile_box">
                                        <object :data="require(`@/assets/images/mypage/profile_box_${each.name}.svg`)" type=""></object>
                                        <div style="font-weight: 700; font-size: 12px; margin-top: 14px;">{{ transTextName(each.name) }}</div>
                                        <div style="font-size: 11px; line-height: 16px;">{{ transContents(each.name) }}</div>
                                        <div v-if="!each.isComplete" style="width: 83px; height: 28px; line-height: 28px; text-align: center; border-radius: 8px; border: 1px solid #210f03; font-size: 12px">설정하기</div>
                                        <div v-else style="width: 53px; height: 28px; display: flex; align-items: center; justify-content: center; border-radius: 8px; background-color: #210f03;">
                                            <img style="width: 13px;" :src="require('@/assets/img/check_white.png')" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 20px;" v-if="mode === MY_VIEW_MODE.ME && !isCompleteProfileBox && isCoach">
                            <div v-if="completeCount < 6" style="display: flex; align-items: center; gap: 4px; justify-content: center;">
                                <img style="width: 12px;" :src="require('@/assets/images/mypage/profile_box_icon.png')" alt="">
                                <div style="font-weight: 700; font-size: 14px;">프로필 박스를 완성해주세요</div>
                            </div>
                            <div v-if="completeCount < 6" style="font-size: 12px;text-align: center; line-height: 20px;"> {{ completeCount }}/6개 완료</div>
                            <div class="hide_scroll" style="display: flex; gap: 12px; overflow-x: scroll; padding: 0 12px; margin-top: 8px;">
                                <div :style="{ display: each.isComplete ? 'none' : 'block' }" @click="setIsOpenSettings(each.name, false, each.isComplete); $Util.sendEventClick(`마이페이지_설정하기_${each.name}`)" v-for="each, i in myProfileBoxList" :key="i">
                                    <div v-if="!each.isComplete" class="my_profile_box">
                                        <object :data="require(`@/assets/images/mypage/profile_box_coach_${each.name}.svg`)" type=""></object>
                                        <div style="font-weight: 700; font-size: 12px; margin-top: 14px;">{{ transTextName(each.name) }}</div>
                                        <div style="font-size: 11px; line-height: 16px;">{{ transContents(each.name) }}</div>
                                        <div v-if="!each.isComplete" style="width: 83px; height: 28px; line-height: 28px; text-align: center; border-radius: 8px; border: 1px solid #210f03; font-size: 12px">설정하기</div>
                                        <div v-else style="width: 53px; height: 28px; display: flex; align-items: center; justify-content: center; border-radius: 8px; background-color: #210f03;">
                                            <img style="width: 13px;" :src="require('@/assets/img/check_white.png')" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!isCoach" style="padding: 0 12px; margin-top: 20px;">
                        <div style="display: flex; gap: 15px; align-items: center; margin-bottom: 20px; ">
                            <div @click="setBtnType(BTN_TYPE.REQUEST)" :class="btnType === BTN_TYPE.REQUEST ? (isSecretProfile ? 'active-secret' : 'active') : 'un_active'" style="font-weight: 700;">입단 요청서</div>
                            <div @click="setBtnType(BTN_TYPE.GROUND)" :class="btnType === BTN_TYPE.GROUND ? (isSecretProfile ? 'active-secret' : 'active') : 'un_active'" style="font-weight: 700;">그라운드</div>
                        </div>
                        <template v-if="btnType === BTN_TYPE.REQUEST">
                            <template v-if="soccerHows.length > 0">
                                <div :class="[
                                    ]"
                                    style="margin-bottom: 20px; padding-bottom: 20px;" v-for="each, i in soccerHows" :key="i + 'post_request'"
                                >
                                    <template v-if="mode === MY_VIEW_MODE.ME">
                                        <CommonRequestForm v-if="each.is_secret == 0" :userInfo="each"></CommonRequestForm>
                                        <CommonSecretRequestForm v-else :userInfo="each"></CommonSecretRequestForm>
                                        <!-- <CommonPost :isExpert="false" :soccerHows="each"></CommonPost> -->
                                    </template>
                                    <template v-else>
                                        <CommonRequestForm v-if="each.is_secret == 0" :userInfo="each"></CommonRequestForm>
                                        <CommonSecretRequestForm v-else :userInfo="each"></CommonSecretRequestForm>
                                    </template>
                                </div>
                            </template>
                            <template v-else>
                                <div style="display: flex; flex-direction: column; align-items: center; padding-top: 10px; padding-bottom: 30px;">
                                    <div class="empty_circle">
                                        <div class="white_circle"></div>
                                        <div class="white_circle"></div>
                                        <div class="white_circle"></div>
                                    </div>
                                    <div class="empty_title">작성한 입단 요청서가 없어요</div>
                                </div>
                            </template>
                        </template>
                        <template v-if="btnType === BTN_TYPE.GROUND">
                            <template v-if="soccerHowsGround.length > 0">
                                <div class="training_box" style="margin-bottom: 20px; padding-bottom: 20px;" v-for="each, i in soccerHowsGround" :key="i + 'post_ground'">
                                    <CommonPost :isExpert="false" :isFeed="true" :soccerHows="each"></CommonPost>
                                </div>
                            </template>
                            <template v-else>
                                <div style="display: flex; flex-direction: column; align-items: center; padding-top: 10px; padding-bottom: 30px;">
                                    <div class="empty_circle">
                                        <div class="white_circle"></div>
                                        <div class="white_circle"></div>
                                        <div class="white_circle"></div>
                                    </div>
                                    <div class="empty_title">작성한 그라운드 게시물이 없어요</div>
                                </div>
                            </template>
                        </template>
                    </div>
                    <div v-if="media && media.media_path" style="border-radius:12px; overflow:hidden; margin:12px 12px 0px 12px; margin-bottom: 60px;">
                        <template v-if="$Util.checkYoutubeLink(media.media_path)">
                            <ContentsViewer :contents="media.media_path" />
                        </template>
                        <template v-else>
                            <img :src="$resourcePath + media.media_path" style="width:100%;" />
                        </template>
                    </div>
                    <!-- <div v-if="mode === MY_VIEW_MODE.ME" style="margin-top: 20px;">
                        <div style="font-weight: 700; padding: 0 12px; line-height: 24px;">모든 서비스</div>
                        <div style="margin-top: 8px;">
                            <div @click="setServiceTab(each); $Util.sendEventClick(`마이페이지_모든서비스_${each.name}`)" v-for="each, i in isCoach ? menuListCoach : menuList" :key="i + 'menuList'" style="">
                                <InteractionOfElementBackgroundColor style="display: flex; align-items: center; justify-content: space-between; padding: 12px 24px;" originColor="#fff" changeColor="#F5F5F5">
                                    <div style="display: flex; align-items: center; gap: 12px;">
                                        <div>
                                            <img style="width: 40px;" :src="require(`@/assets/images/mypage/my_page_${each.imagePathKey}.png`)" alt="">
                                        </div>
                                        <div style="font-weight: 500;">{{ each.name }}</div>
                                    </div>
                                    <div>
                                        <img style="width: 10px;" :src="require('@/assets/img/counsel_arrow.png')" alt="">
                                    </div>
                                </InteractionOfElementBackgroundColor>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div v-if="isPopup" style="height:108px;"></div>
            </InfinityScroll>
        </div>
        <div v-if="showContents && isPopup && !isCoach && isMeCoach" style="height: 108px; width: 100%; bottom: 0; position: absolute; background-color: transparent; z-index: 10;">
            <div style="display: flex; justify-content: center;  gap: 9px; margin-top: 8px; padding: 0 12px;">
                <div v-if="!isMeCoach && !isCoach" @touchstart="touchStart($event)" @touchend="touchEnd($event)" ref="ballWrapper" style="flex: 1; transition: all 0.3s; display: flex; position: relative; justify-content: center; align-items: center; gap: 4px; height: 60px; border-radius: 50px; font-size: 14px; font-weight: 700; background-color: var(--color-main);">
                    <img ref="shoot" style="width: 62px; z-index: 1; opacity: 0; position: absolute;" :src="require('@/assets/img/shoot_red.png')" alt="">
                    <img ref="soccerBall" style="width: 24px; position: relative; z-index: 2; left: 0;" :src="require('@/assets/img/soccer_ball2.png')" alt="">
                </div>
                <div @click="setLike" v-if="isMeCoach" class="coach_class">
                    <img v-if="!isShooting" style="width: 16px" :src="require('@/assets/img/star_black.png')" alt="">
                    <img v-else style="width: 16px" :src="require('@/assets/img/like_star.png')" alt="">
                    <div>관심</div>
                </div>
                <div @click="sendDirectMessage" style="width:200px; height: 60px; gap: 4px; display: flex; justify-content: center; align-items: center; border-radius: 50px; font-size: 14px; font-weight: 700; background-color: #210f03; color: var(--color-main);">
                    <img style="width: 16px" :src="require('@/assets/img/dm_main_color.png')" alt="">
                    <div>다이렉트 메시지</div>
                </div>
            </div>
        </div>
        <div v-if="showContents && isPopup && isCoach && !isMeCoach" style="height: 108px; width: 100%; bottom: 0; position: absolute; background-color: transparent; z-index: 10;">
            <div style="display: flex; justify-content: center;  gap: 9px; margin-top: 8px; padding: 0 12px;">
                <div @click="confirmMyTrainingVideo(false)" class="coach_class">
                    <img style="width: 17px" :src="require('@/assets/img/feed_back.png')" alt="">
                    <div>훈련 피드백 받기</div>
                </div>
                <div v-if="teamInfo && teamInfo.is_deleted == 0" @click="confirmMySoccerhow(false)" style="width:200px; height: 60px; gap: 4px; display: flex; justify-content: center; align-items: center; border-radius: 50px; font-size: 14px; font-weight: 700; background-color: #210f03; color: var(--color-main);">
                    <img style="width: 16px" :src="require('@/assets/img/dm_main_color.png')" alt="">
                    <div>입단 요청서 보내기</div>
                </div>
            </div>
        </div>
        <div :class="{ 'move-up-right': isShootMe }" style="position: absolute; bottom: 0; transform: translate(-100%, 100%);">
            <img style="width: 264px;" :src="require('@/assets/img/shoot_me.png')" alt="">
        </div>
        <PageBottom v-if="mode === MY_VIEW_MODE.ME && !isForceModal" :isShowMakeFeed="false"></PageBottom>
        <div v-if="isSecretProfile" :style="{ height: $GlobalStore.navigationBarHeight() + 'px' }" style="background-color: #fff; position: fixed; bottom: 0; width: 100%;">

        </div>
        <SettingPlace :isOpen="settingsArray[0].isOpenSettingPlace" :closeCompleteAction="setIsOpenSettings"></SettingPlace>
        <SettingDisplayTag :isOpen="settingsArray[3].isOpenSettingUseReason" :closeCompleteAction="setIsOpenSettings"></SettingDisplayTag>
        <SettingUseReason :isOpen="settingsArray[2].isOpenSettingUseReason" :closeCompleteAction="setIsOpenSettings"></SettingUseReason>
        <SettingHeight :isOpen="settingsArray[4].isOpenSettingHeight" :pcloseCompleteAction="setIsOpenSettings"></SettingHeight>
        <SettingFootWay :isOpen="settingsArray[5].isOpenSettingFootWay" :closeCompleteAction="setIsOpenSettings"></SettingFootWay>
        <SettingSpecialSkill :isOpen="settingsArray[6].isOpenSettingSpecialSkill" :closeCompleteAction="setIsOpenSettings"></SettingSpecialSkill>
        <SettingPlayStyle :isOpen="settingsArray[7].isOpenSettingPlayStyle" :closeCompleteAction="setIsOpenSettings"></SettingPlayStyle>
        <SettingLicense :isOpen="settingsArray[8].isOpenSettingLicense" :closeCompleteAction="setIsOpenSettings"></SettingLicense>
        <BottomPopupMenu :is-open="isShowPopupMenu" :menu-options="menuOptions"></BottomPopupMenu>
        <InviteMySchedule :memberInfo="memberInfo" :mode="mode" :isOpen="isOpenInviteScheduleModal" :closeCompleteAction="closeInviteScheduleModal"></InviteMySchedule>
        <div style="">
            <MercenaryScheduleDetail :scheduleDetailIdx="scheduleDetailIdx" :isOpenScheduleDetail="isOpenScheduleDetail" :closeScheduleDetail="closeScheduleDetail"></MercenaryScheduleDetail>
        </div>
        <CommonBookMarkPopup :height="473" :isShowBookmarkPopup="isShowRequestReportConfirm" :closeBookmarkPopup="() => { isShowRequestReportConfirm = false }">
            <div @click="() => { isShowRequestReportConfirm = false }" style="font-weight: 700;">닫기</div>
            <div>
                <div style="margin-top: 40px; text-align: center;">
                    <img style="width: 250px" :src="require('@/assets/img/bookmark_logo2.png')" alt="">
                </div>
                <div style="margin-top: 24px; text-align: center; white-space: nowrap; font-weight: 700; font-size: 20px; line-height: 32px;">다이렉트 요청서를 보내지 않아<br>볼 수 있는 요청서 리포트가 없어요!</div>
                <div style="display: flex; gap: 12px; margin-top: 60px;">
                    <div @click="() => { isShowRequestReportConfirm = false; }" style="flex: 1; font-weight: 700; font-size: 14px; line-height: 56px; text-align: center; height: 56px; border-radius: 50px; background-color: #fff;">알겠어요</div>
                    <div @click="() => { isShowRequestReportConfirm = false; isShowMakeRequestJoinForm = true; }" style="flex: 1; font-weight: 700; font-size: 14px; line-height: 56px; color: var(--color-main); text-align: center; height: 56px; border-radius: 50px; background-color: #210f03;">다이렉트 요청서 보낼게요</div>
                </div>
            </div>
        </CommonBookMarkPopup>
        <BookmarkPopup :height="254" :isShowBookmarkPopup="isShowRequestConfirmPopup" :closeBookmarkPopup="closeRequestConfirmPopup">
            <div>
                <div @click="closeRequestConfirmPopup" style="font-weight: 700;">닫기</div>
                <div v-html="requestTitle" style="margin-top: 20px; font-size: 20px; line-height: 33px; font-weight: 700; text-align: center;"></div>
                <div v-if="isExistSoccerhow" @click="sendRequestForm" style="width: 255px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">네, 직접 보낼게요</div>
                <div v-else @click="showRequestJoinForm" style="width: 255px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">입단 요청서 만들기</div>
            </div>
        </BookmarkPopup>
        <BookmarkPopup :height="254" :isShowBookmarkPopup="isShowTrainingVideoPopup" :closeBookmarkPopup="closeTrainingVideoPoopup">
            <div>
                <div @click="closeTrainingVideoPoopup" style="font-weight: 700;">닫기</div>
                <div v-html="feedbackTitle" style="margin-top: 20px; font-size: 20px; line-height: 33px; font-weight: 700; text-align: center;"></div>
                <div @click="receiveFeedback" v-if="isExistTrainingVideo" style="width: 255px; margin: 0 auto; height: 56px; display: flex; justify-content: center; gap: 8px; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">
                    <img style="width: 17px" :src="require('@/assets/img/feed_back.png')" alt="">
                    <div>훈련 피드백 받기</div>
                </div>
                <div v-else @click="makeTrainingVideo" style="width: 255px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">훈련 영상 만들기</div>
            </div>
        </BookmarkPopup>
        <CommonPopupFrame :isBlur="true" background="#fffc" :changeBottom="0" :changeHeight="100" :isOpen="isShowRequestForm" :closeCompleteAction="closeRequestForm">
            <div @click="closeRequestForm" style="padding: 16px 20px; font-weight: 700; width: 100px;">닫기</div>
                <div style="flex: 1; overflow-y: scroll; padding: 0 12px;">
                    <div style="text-align: center; margin-top: 60px; font-size: 20px; font-weight: 700; line-height: 33px; margin-bottom: 40px;">아래의 요청서를 전달할게요</div>
                    <div style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px; border-radius: 12px;" v-if="Object.keys(requestInfo).length > 0">
                        <CommonPost :hideOption="true" :isDetail="true" :isFeed="true" :soccerHows="requestInfo"></CommonPost>
                    </div>
                </div>
            <div style="padding: 0 12px;">
                <div @click="showPayForm" style="margin-bottom: 40px; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">보내기</div>
            </div>
        </CommonPopupFrame>
        <CommonPopupFrame :isBlur="true" background="#fffc" :changeBottom="0" :changeHeight="100" :isOpen="isShowTrainingVideoList" :closeCompleteAction="closeTrainingVideoList">
            <div @click="closeTrainingVideoList" style="padding: 16px 20px; font-weight: 700; width: 100px;">닫기</div>
            <template v-if="videoStep === 1">
                <div @touchmove.stop="()=>{}" style="flex: 1; overflow-y: scroll; padding: 0 12px; position: relative; padding-bottom: 100px;">
                    <div style="text-align: center; margin-top: 12px; font-size: 20px; font-weight: 700; line-height: 33px; margin-bottom: 20px;">피드백을 받고 싶은 영상을<br>선택하세요</div>
                    <div style="padding-bottom: 16px; border-bottom: 1px solid #d9d9d9; padding-top: 16px;" v-for="each, i in trainingVideoList" :key="i" >
                        <div @click="selectTrainingVideo(each)" style="position-try-order: relative; background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px; border-radius: 12px;">
                            <div :style="{backgroundColor: each.idx === selectedTrainingVideo.idx ? 'var(--color-main)' : '#E7E7E7'}" style="position: absolute; width: 20px; height: 20px; border: 2px solid #210f03; border-radius: 50%; right: 24px; display: flex; justify-content: center; align-items: center;">
                                <img style="width: 9px;" :src="require('@/assets/img/white_check.png')" alt="">
                            </div>
                            <CommonPost :clickEvent="selectTrainingVideo" :preventClick="true" :hideOption="true" :isFeed="true" :soccerHows="each"></CommonPost>
                        </div>
                    </div>
                    <div style="padding: 0 12px; position: fixed; bottom: 0; width:100%;">
                        <div @click="nextStep" :class="Object.keys(selectedTrainingVideo).length > 0 ? 'btn_active' : 'btn_un_active'" class="next_btn">다음</div>
                    </div>
                </div>
            </template>
            <template v-if="videoStep === 2">
                <div style="flex: 1; overflow-y: scroll; padding: 0 12px;">
                    <div style="text-align: center; margin-top: 12px; font-size: 20px; font-weight: 700; line-height: 33px; margin-bottom: 40px;">아래의 훈련 영상을 전달할게요</div>
                    <div style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px; border-radius: 12px;" v-if="Object.keys(selectedTrainingVideo).length > 0">
                        <CommonPost :preventClick="true" :hideOption="true" :isFeed="true" :soccerHows="selectedTrainingVideo"></CommonPost>
                    </div>
                </div>
                <div style="padding: 0 12px;">
                    <div @click="sendTrainingVideo" style="margin-bottom: 40px; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">보내기</div>
                </div>
            </template>
            <template v-if="videoStep === 3">
                <div style="margin-top: 103px; flex: 1; text-align: center;">
                    <div>
                        <div :style="{opacity: completeStep === 2 ? 1 : 0}" style="font-weight: 700; font-size: 20px; line-height: 32px; margin-bottom: 40px;">좋은 피드백이 있길 바래요!</div>
                        <ProfileImage :imagePath="memberInfo.image_path" style="width: 80px;"></ProfileImage>
                        <div v-if="teamInfo" style="margin-top: 4px; color: #b5aaa3; font-weight: 700; font-size: 12px; line-height: 24px;">{{ teamInfo.name }}</div>
                        <div v-show="completeStep === 1">
                            <div style="font-weight: 500; margin-top: 40px;  font-size: 20px; line-height: 32px;"><span style="font-weight: 700;">{{ memberInfo.name }}님</span>에게<br>훈련 영상을 전달중입니다 ...</div>
                        </div>
                        <div v-show="completeStep === 2" style="margin-top: 40px; ">
                            <div style="font-weight: 500; font-size: 14px; line-height: 18px; margin-top: 20px;">훈련 영상 보내기</div>
                            <div style="margin-top: 4px; font-weight: 800; font-size: 20px; line-height: 32px;">피드백을 기다리는 동안,<br>훈련으로 한층 더 성장해보세요</div>
                        </div>
                    </div>
                    <div style="margin-top: 40px; padding: 0 12px;">
                        <ProgressBar v-show="completeStep === 1" :hideProgressBar="hideProgressBar" :isStart="isStart"></ProgressBar>
                        <div @click="showMyTrainingVideo" v-show="completeStep === 2" style="width: 323px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700;">내 훈련 영상으로 이동하기</div>
                    </div>
                </div>
            </template>
        </CommonPopupFrame>
        <MakeRequestJoinForm  :isShowMakeRequestJoinForm="isShowMakeRequestJoinForm" :closeRequestJoinForm="() => { isShowMakeRequestJoinForm = false }"></MakeRequestJoinForm>
        <LearnSoccerWriteForm :completeAction="beforeCompleteAction" :refer_idx="refer_idx" :isShowWriteForm="isShowWriteForm" :closeWriteForm="closeWriteForm" :formType="FORM_TYPE.TRAINING"></LearnSoccerWriteForm>
        <NotExpert :isOpen="isShowNotExpert" :closeModal="closeNotExpert"></NotExpert>
        <NoTeam :isOpen="isShowNoTeam" :closeModal="closeNoTeam"></NoTeam>
        <BookmarkPopup :height="336" :isShowBookmarkPopup="isShowConfirmHistory" :closeBookmarkPopup="closeConfirmHistory">
            <div>
                <div @click="closeConfirmHistory" style="font-weight: 700;">닫기</div>
                <div style="text-align: center; margin-top: 6px; margin-right: 60px;">
                    <img style="width: 249px;" :src="require('@/assets/img/confirm_history.png')" alt="">
                </div>
                <div style="margin-top: 20px; font-size: 20px; line-height: 24px; font-weight: 700; text-align: center;">작성해주신 경력을 확인 중이에요.<br>잠시만 기다려주세요.</div>
                <div style="margin-top: 8px; font-size: 12px; color: #606060; text-align: center;">보내주신 정보는 확인 후 수정되거나 반려될 수 있습니다</div>
                <div @click="closeConfirmHistory" style="width: 185px; margin: 0 auto; margin-top: 10px; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; ">확인</div>
            </div>
        </BookmarkPopup>
        <template v-if="coachHistory">
            <CommonPopupFrame :changeBottom="0" :changeHeight="100" :isOpen="isShowCoachHistoryPop" :closeCompleteAction="closeCoachHistoryPop">
                <div style=" background-color: #121723; border-top-right-radius: 24px; border-top-left-radius: 24px;">
                    <div style="text-align: center; display: flex; flex-direction: column; align-items: center; margin-top: 24px;">
                        <div style="width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; background-color: var(--color-main);">
                            <img style="width: 20px;" :src="require('@/assets/img/career_main.png')" alt="">
                        </div>
                        <div style="font-weight: 700; font-size: 20px; line-height: 32px; color: #fff; margin-top: 5px;">전문가 경력 상세</div>
                        <div style="padding: 5px 12px; border-radius: 20px; border: 1px solid #fff; background: #1D2530; color: var(--color-main); margin-top: 5px; font-weight: 500; margin-bottom: 37px;">지도자 경력 {{ coachHistory.career_period }}</div>
                    </div>
                </div>
                <div @touchmove.stop="() => {}" style="flex: 1; overflow-y: scroll; border-top-right-radius: 24px; border-top-left-radius: 24px; margin-top: -20px; background-color: #fff; padding: 40px;">
                    <div style="display: flex; align-items: center; gap: 5px;">
                        <img style="width: 12px;" :src="require('@/assets/img/license_report.png')" alt="">
                        <div style="font-weight: 500; font-size: 12px;">지도자 커리어</div>
                    </div>
                    <div style="padding-left: 6px; margin-top: 15px;">
                        <div v-for="each, i in coachPeriod" :key="i + 'period'" style="display: flex; gap: 12px;">
                            <div style="display: flex; flex-direction: column; align-items: center; gap: 2px; margin-top: 6px;">
                                <div style="width: 9px; height: 9px; border-radius: 50%; background-color: var(--color-main);"></div>
                                <div v-if="i !== coachPeriod.length - 1" style="height: 60px; width: 1px; background-color: #ececec;"></div>
                            </div>
                            <div>
                                <div style="font-weight: 700; line-height: 20px;">{{ each.team_name }}</div>
                                <div style="display: flex; align-items: center; gap: 5px; margin-top: 8px;">
                                    <img style="width: 10px;" :src="require('@/assets/img/calendar_gray.png')" alt="">
                                    <div style="font-weight: 500; color: #606060; font-size: 12px; line-height: 16px;">{{ each.period }}</div>
                                </div>
                            </div>
                        </div>
                        <div style="margin-top: 13px;">
                            <div style="border-radius: 12px; background-color: #F8F9FA; border: 1px solid #f1f2f5; padding: 20px;">
                                <div style="display: flex; align-items: center; gap: 5px;">
                                    <img style="width: 15px;" :src="require('@/assets/img/player_period.png')" alt="">
                                    <div style="font-weight: 500; font-size: 12px; color: #606060;">선수 시절</div>
                                </div>
                                <div style="padding-left: 20px;">
                                    <div style="display: flex; align-items: center; gap: 5px; margin-top: 5px;">
                                        <img style="width: 10px;" :src="require('@/assets/img/calendar_gray.png')" alt="">
                                        <div style="font-weight: 500; color: #606060; font-size: 12px; line-height: 16px;">{{ playerPeriod[0].period }}</div>
                                    </div>
                                    <div style="margin-top: 7px; display: flex; gap: 9px; flex-wrap: wrap;">
                                        <div v-for="each, i in playerPeriod" :key="i + 'period_player'" style="padding: 4px 10px; flex-shrink: 0; line-height: 16px; font-size: 12px; font-weight: 500; background-color: #fff; border: 1px solid #d9d9d9; border-radius: 4px;">{{ each.team_name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="padding: 0 52px; padding-bottom: 40px; padding-top: 20px;">
                    <div @click="closeCoachHistoryPop" style="height: 56px; line-height: 56px; color: var(--color-main); font-size: 14px; font-weight: 700; text-align: center; border-radius: 50px; background-color: #210f03;">확인</div>
                </div>
            </CommonPopupFrame>
        </template>
        <template v-else>
            <div v-if="isShowCoachHistoryPop" @click="closeCoachHistoryPop" style="z-index: 100; position: fixed; width: 100%; height: 100%; top: 0; left: 0; display: flex; justify-content: center; align-items: center; background-color: #210f0380;">
                <div style="width: 293px; max-height: 402px; overflow: hidden; display: flex; flex-direction: column; background-color: #fff; border-radius: 12px;">
                    <div @click="closeCoachHistoryPop" style="margin-left: 20px; margin-top: 16px; font-weight: 700;">닫기</div>
                    <div style="margin-top: 32px; text-align: center; font-weight: 700; color: var(--color-main); margin-bottom: 17px;">코치님 프로필이 준비 중이에요 📋</div>
                    <div style="">
                        <img style="width: 100%; vertical-align: top;" :src="require('@/assets/img/no_coach_history.png')" alt="">
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import PageBottom from '@/components/common/PageBottom'
import MyCurrentScout from '@/components/common/MyCurrentScout'
import NotExpert from '@/components/common/NotExpert'
import NoTeam from '@/components/common/NoTeam'
import ProgressBar from '@/components/soccerhowmain/ProgressBar';
import ProfileImage from '@/components/common/ProfileImage'
import BottomPopupMenu from '@/components/common/BottomPopupMenu'
import LearnSoccerWriteForm from '@/components/soccerhowmain/LearnSoccerWriteForm'
import SettingPlace from '@/components/common/SettingPlace'
import SettingDisplayTag from '@/components/common/SettingDisplayTag'
import SettingUseReason from '@/components/common/SettingUseReason'
import SettingHeight from '@/components/common/SettingHeight'
import BookmarkPopup from '@/components/soccerhowmain/BookmarkPopup';
import SettingFootWay from '@/components/common/SettingFootWay'
import SettingSpecialSkill from '@/components/common/SettingSpecialSkill'
import SettingLicense from '@/components/common/SettingLicense'
import SettingPlayStyle from '@/components/common/SettingPlayStyle'
import { MY_VIEW_MODE, MEMBER_CAREER_HISTORY_STATE, PROFILE_FOOT_WAY, initialRouteStr, PROFILE_BOX_LIST, FEED_VIEW_TYPE, SOCCER_HOW_TYPE, IS_COACH, JOIN_CHAT_TYPE, TEAM_TYPE, SOCCER_HOW_TEAM_DETAIL_FROM_SCREEN } from '@/Constants'
import MercenaryScheduleDetail from '@/components/common/MercenaryScheduleDetail'
import InfinityScroll from '@/components/common/InfinityScroll'
import ContentsViewer from "../common/ContentsViewer";
import { JOIN_STATE, FIND_POSITION_PRO_TITLE, NOTICE_TYPE, MAIN_TYPE, VISIT_REASON_TYPE } from "../../Constants";
import InviteMySchedule from "@/components/common/InviteMySchedule"
import ResponseCode from '../../ResponseCode'
import CommonBookMarkPopup from "../soccerhowmain/CommonBookMarkPopup";
import MakeRequestJoinForm from "../soccerhowmain/MakeRequestJoinForm";
// import AlarmIcon from '@/components/common/AlarmIcon'
import MercenaryHeader from '@/components/common/MercenaryHeader'
import InteractionOfScale from '@/components/common/InteractionOfScale'
import PedometerSimple from '@/components/common/PedometerSimple'
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
// import InteractionOfElementBackgroundColor from '@/components/common/InteractionOfElementBackgroundColor'
import CommonPost from '@/components/soccerhowmain/CommonPost'
import CommonRequestForm from '@/components/common/CommonRequestForm'
import CommonSecretRequestForm from '@/components/common/CommonSecretRequestForm'
import moment from 'moment'
// import DivisionPositionText from '@/components/common/DivisionPositionText'

const FEED_TYPE = {
    MY_FEED: 'my_feed',
    JOIN_FEED: 'join_feed'
}

const MENU_LIST_KEY = {
    POSITION: 'position',
    WRITE: 'write',
    REQUEST: 'request',
    SPOTLIGHT: 'spotlight',
    NEWS: 'news',
    INQUIRY: 'inquiry',
    MY_TEAM: 'my_team',
    TEAM_TRAINING: 'team_training',
    NOTICE: 'notice'
}

const BTN_TYPE = {
    REQUEST: '입단요청서',
    GROUND: '그라운드',
}

const FORM_TYPE = {
    TOPIC: 'TOPIC',
    SKILL: 'SKILL',
    TRAINING: 'TRAINING'
}

const GRADE_NAME = {
    BALL_BOY: '볼보이',
    RISING_STAR: '유망주',
    ACE: '에이스',
    WORLD_CLASS: '월드 클래스'
}


export default {
    name: 'ProfileMain',
    components: {
        MakeRequestJoinForm, CommonPost, PedometerSimple, LearnSoccerWriteForm, MyCurrentScout,
        CommonBookMarkPopup, MercenaryHeader, CommonPopupFrame, NotExpert, CommonRequestForm,
        ContentsViewer, InteractionOfScale, BookmarkPopup, ProgressBar, NoTeam,CommonSecretRequestForm,
        PageBottom, InviteMySchedule, SettingLicense, BottomPopupMenu, MercenaryScheduleDetail, InfinityScroll, ProfileImage, SettingPlace, SettingDisplayTag, SettingUseReason, SettingHeight, SettingFootWay, SettingSpecialSkill, SettingPlayStyle, 
    },
    props: {
        memberIdx: {
            type: [String, Number],
            default: -1
        },
        mode: {
            type: Number,
            default: MY_VIEW_MODE.ME
        },
        isForceModal: {
            type: Boolean,
            default: false,
        },
        isPopup: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isElitePlayer: false,
            remainPercent: 0,
            GRADE_NAME: GRADE_NAME,
            MEMBER_CAREER_HISTORY_STATE: MEMBER_CAREER_HISTORY_STATE,
            VISIT_REASON_TYPE: VISIT_REASON_TYPE,
            FORM_TYPE: FORM_TYPE,
            isShowRequestForm: false,
            TEAM_TYPE: TEAM_TYPE,
            SOCCER_HOW_TEAM_DETAIL_FROM_SCREEN: SOCCER_HOW_TEAM_DETAIL_FROM_SCREEN,
            BTN_TYPE: BTN_TYPE,
            innerShape1: 'M96 164.675C96 163.773 96.6043 162.982 97.4751 162.746C97.4751 162.746 194.475 136.361 194.475 136.361C194.819 136.267 195.181 136.267 195.525 136.361C195.525 136.361 292.525 162.746 292.525 162.746C293.396 162.982 294 163.773 294 164.675C294 164.675 294 353.593 294 353.593C294 354.498 293.393 355.289 292.52 355.525C292.52 355.525 195.52 381.646 195.52 381.646C195.179 381.738 194.821 381.738 194.48 381.646C194.48 381.646 97.4799 355.525 97.4799 355.525C96.6068 355.289 96 354.498 96 353.593C96 353.593 96 164.675 96 164.675Z',
            innerShape2: 'M58 109.472C58 108.552 58.6282 107.75 59.5219 107.53C59.5219 107.53 194.522 74.2968 194.522 74.2968C194.836 74.2195 195.164 74.2195 195.478 74.2968C195.478 74.2968 330.478 107.53 330.478 107.53C331.372 107.75 332 108.552 332 109.472C332 109.472 332 344.864 332 344.864C332 345.786 331.37 346.589 330.474 346.807C330.474 346.807 195.474 379.709 195.474 379.709C195.162 379.785 194.838 379.785 194.526 379.709C194.526 379.709 59.5264 346.807 59.5264 346.807C58.6305 346.589 58 345.786 58 344.864C58 344.864 58 109.472 58 109.472Z',
            shape1Fill: 'M62 149.636C62 138.816 69.2407 129.333 79.6791 126.483C79.6791 126.483 188.679 96.7256 188.679 96.7256C192.817 95.5959 197.183 95.5959 201.321 96.7256C201.321 96.7256 310.321 126.483 310.321 126.483C320.759 129.333 328 138.816 328 149.636C328 149.636 328 368.678 328 368.678C328 379.521 320.73 389.017 310.262 391.847C310.262 391.847 201.262 421.307 201.262 421.307C197.161 422.416 192.839 422.416 188.738 421.307C188.738 421.307 79.7379 391.847 79.7379 391.847C69.2704 389.017 62 379.521 62 368.678C62 368.678 62 149.636 62 149.636Z',
            shape2Fill: 'M32 104.085C32 93.0483 39.5265 83.4346 50.2403 80.786C50.2403 80.786 189.24 46.4238 189.24 46.4238C193.023 45.4887 196.977 45.4887 200.76 46.4238C200.76 46.4238 339.76 80.786 339.76 80.786C350.473 83.4346 358 93.0483 358 104.085C358 104.085 358 350.272 358 350.272C358 361.329 350.446 370.956 339.705 373.584C339.705 373.584 200.705 407.604 200.705 407.604C196.957 408.521 193.043 408.521 189.295 407.604C189.295 407.604 50.2945 373.584 50.2945 373.584C39.5544 370.956 32 361.329 32 350.272C32 350.272 32 104.085 32 104.085Z',
            strokePath1: 'M68 149.636C68 141.521 73.4305 134.409 81.2594 132.272C81.2594 132.272 190.259 102.514 190.259 102.514C193.363 101.666 196.637 101.666 199.741 102.514C199.741 102.514 308.741 132.272 308.741 132.272C316.57 134.409 322 141.521 322 149.636C322 149.636 322 368.678 322 368.678C322 376.81 316.547 383.932 308.697 386.054C308.697 386.054 199.697 415.515 199.697 415.515C196.621 416.347 193.379 416.347 190.303 415.515C190.303 415.515 81.3034 386.054 81.3034 386.054C73.4528 383.932 68 376.81 68 368.678C68 368.678 68 149.636 68 149.636Z',
            strokePath2: 'M38 104.085C38 95.8074 43.6449 88.5971 51.6803 86.6107C51.6803 86.6107 190.68 52.2485 190.68 52.2485C193.517 51.5471 196.483 51.5471 199.32 52.2485C199.32 52.2485 338.32 86.6107 338.32 86.6107C346.355 88.5971 352 95.8074 352 104.085C352 104.085 352 350.272 352 350.272C352 358.565 346.334 365.785 338.279 367.756C338.279 367.756 199.279 401.776 199.279 401.776C196.468 402.464 193.532 402.464 190.721 401.776C190.721 401.776 51.7209 367.756 51.7209 367.756C43.6658 365.785 38 358.565 38 350.272C38 350.272 38 104.085 38 104.085Z',
            currentPath: '',
            currentPath2: '',
            currentPathStroke: '',
            visitReasonType: this.$GlobalStore.getVisitReasonType(),
            isShape1: true,
            JOIN_STATE: JOIN_STATE,
            isShowPopupMenu: false,
            scheduleDetailIdx: -1,
            isOpenScheduleDetail: false,
            memberTalkDetailIdx: -1,
            isOpenMemberTalkDetail: false,
            MY_VIEW_MODE: MY_VIEW_MODE,
            PROFILE_FOOT_WAY: PROFILE_FOOT_WAY,
            memberInfo: {},
            isComplete: false,
            disableToggle: false,
            isCompleteProfileBox: false,
            is_me_liked: false,
            specialSkillIndex: 0,
            useReasonsIndex: 0,
            playStyleIndex: 0,
            IS_COACH: IS_COACH,
            isEnableNextPageHandle: true,
            menuOptions: {},
            completeProfileBoxList: [
                PROFILE_BOX_LIST.AGE_RANGE,
                PROFILE_BOX_LIST.HEIGHT,
                PROFILE_BOX_LIST.FOOT_WAY,
                PROFILE_BOX_LIST.SPECIAL_SKILL,
                PROFILE_BOX_LIST.PLAY_STYLE,
                PROFILE_BOX_LIST.PLACE_NAME,
                PROFILE_BOX_LIST.USE_REASONS,
                PROFILE_BOX_LIST.VISIT_REASONS
            ],
            multipleBox: [],
            menuList: [
                { imagePathKey: MENU_LIST_KEY.POSITION, name: '포지션 찾기', },
                { imagePathKey: MENU_LIST_KEY.SPOTLIGHT, name: '감터뷰', },
                { imagePathKey: MENU_LIST_KEY.WRITE, name: '내가 작성한 글', },
                { imagePathKey: MENU_LIST_KEY.REQUEST, name: '요청서 리포트', },
                { imagePathKey: MENU_LIST_KEY.NOTICE, name: '공지사항', },
                // { imagePathKey: MENU_LIST_KEY.NEWS, name: '입단 소식', },
                { imagePathKey: MENU_LIST_KEY.INQUIRY, name: '문의하기', },
            ],
            menuListCoach: [
                { imagePathKey: MENU_LIST_KEY.POSITION, name: '포지션 찾기', },
                { imagePathKey: MENU_LIST_KEY.SPOTLIGHT, name: '감터뷰', },
                { imagePathKey: MENU_LIST_KEY.WRITE, name: '나에게 온 다이렉트 요청서', },
                { imagePathKey: MENU_LIST_KEY.TEAM_TRAINING, name: '트레이닝 관리', },
                { imagePathKey: MENU_LIST_KEY.MY_TEAM, name: '내 팀 정보', },
                { imagePathKey: MENU_LIST_KEY.NOTICE, name: '공지사항', },
                // { imagePathKey: MENU_LIST_KEY.NEWS, name: '입단 소식', },
                { imagePathKey: MENU_LIST_KEY.INQUIRY, name: '문의하기', },
            ],
            profileBoxList: [],
            checkProfileBoxList: [],
            MENU_LIST_KEY: MENU_LIST_KEY,
            showContents: false,
            myProfileBoxList: [

            ],
            completeCount: 0,
            feedType: FEED_TYPE.MY_FEED,
            FEED_TYPE: FEED_TYPE,
            feedList: [
                { key: 'all', name: '모든 피드', uniqueKey: false },
                { key: 'feed_category', name: '피드 유형', uniqueKey: true },
                { key: 'shooting', name: '슈팅', uniqueKey: false },
                { key: 'reply', name: '댓글', uniqueKey: false },
                { key: 'answer', name: '답글', uniqueKey: false },
            ],
            selectFeed: 'all',
            selectDetailFeed: null,
            settingsArray: [
                { isOpenSettingPlace: false, name: PROFILE_BOX_LIST.PLACE_NAME },
                { isOpenSettingPosition: false, name: PROFILE_BOX_LIST.POSITION },
                { isOpenSettingDisplayTag: false, name: PROFILE_BOX_LIST.DISPLAY_TAG },
                { isOpenSettingUseReason: false, name: PROFILE_BOX_LIST.USE_REASONS },
                { isOpenSettingHeight: false, name: PROFILE_BOX_LIST.HEIGHT },
                { isOpenSettingFootWay: false, name: PROFILE_BOX_LIST.FOOT_WAY },
                { isOpenSettingSpecialSkill: false, name: PROFILE_BOX_LIST.SPECIAL_SKILL },
                { isOpenSettingPlayStyle: false, name: PROFILE_BOX_LIST.PLAY_STYLE },
                { isOpenSettingLicense: false, name: PROFILE_BOX_LIST.LICENSE },
                { isOpenSettingVisitReason: false, name: PROFILE_BOX_LIST.VISIT_REASONS },
                { isOpenSettingExpertInfo: false, name: PROFILE_BOX_LIST.EXPERT_INFO },
            ],
            PROFILE_BOX_LIST: PROFILE_BOX_LIST,
            page: 1,
            FEED_VIEW_TYPE: FEED_VIEW_TYPE,
            SOCCER_HOW_TYPE: SOCCER_HOW_TYPE,
            myFeedList: [],
            media: {},
            lessons: [],
            isOpenInviteScheduleModal: false,
            JOIN_CHAT_TYPE: JOIN_CHAT_TYPE,
            myPositions: [],
            isAgeOrSex: PROFILE_BOX_LIST.AGE_RANGE,
            isHeightOrFootWay: PROFILE_BOX_LIST.HEIGHT,
            isShooting: false,
            isShootMe: false,
            isFriend: false,
            month_period_view_cnt: 0,
            teamInfo: {},
            mine_ranking: {},
            isShowRequestReportConfirm: false,
            isShowMakeRequestJoinForm: false,
            isShowBackGroundImage: false,
            btnType: BTN_TYPE.REQUEST,
            from_screen: SOCCER_HOW_TEAM_DETAIL_FROM_SCREEN.DEFAULT,
            soccerHows: [],
            soccerHowsGround: [],
            trainingDate: [
                { day: '월', count: 0 },
                { day: '화', count: 0 },
                { day: '수', count: 0 },
                { day: '목', count: 0 },
                { day: '금', count: 0 },
                { day: '토', count: 0 },
                { day: '일', count: 0 },
            ],
            total_view_cnt: 0,
            scout_cnt: 0,
            training_cnt: 0,
            favorite_member_cnt: 0,
            memberStats: {},
            trainingAmount: [],
            intervals: [],
            isExistSoccerhow: false,
            requestInfo: {},
            isShowRequestConfirmPopup: false,
            isShowTrainingVideoPopup: false,
            isExistTrainingVideo: false,
            isShowTrainingVideoList: false,
            trainingVideoList: [],
            selectedTrainingVideo: {},
            videoStep: 1,
            isShowWriteForm: false,
            bannerList: [],
            refer_idx: -1,
            isStart: false,
            completeStep: 1,
            feedbackTitle: '',
            requestTitle: '',
            isShowNotExpert: false,
            isShowNoTeam: false,
            isShowConfirmHistory: false,
            isShowCoachHistoryPop: false,
            coachHistory: null,
            coachPeriod: [],
            gradeList: [],
            myGradeImagePath: '',
            myGradeName: '',
            nextPlayer: '',
            remainPoint: 0,
            groundPage: 1,
            playerPeriod: []
        }
    },
    mounted() {
        setTimeout(() => {
            this.currentPath = this.shape1Fill;
            this.currentPath2 = this.innerShape1
            this.currentPathStroke = this.strokePath1
        }, 500)

    },
    computed: {
        copyMemberIdx() {
            if (this.mode === MY_VIEW_MODE.ME) {
                return this.$GlobalStore.loginInfo().idx
            } else {
                return this.memberIdx
            }
        },
        isCoach() {
            if (this.memberInfo.is_temp_coach == 1) {
                return true
            } else {
                return false
            }
        },
        isSecretProfile() {
            return this.memberInfo.is_secret == 1
        },
        isMeCoach() {
            if (this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().is_temp_coach == 1) {
                return true
            } else {
                return false
            }
        },
        isPositionBox() {
            let positionType = '';
            if (this.memberInfo.position === null) {
                positionType = ''
            } else if (this.memberInfo.is_direct_position == 1) {
                positionType = ''
            } else if (this.memberInfo.position !== null && this.memberInfo.position_pro_ability === null) {
                positionType = ''
            } else if (this.memberInfo.position_pro_ability !== null && this.memberInfo.position !== null) {
                positionType = ''
            }
            return positionType
        },
        transText() {
            return (key) => {  // index의 기본값은 0
                switch (key) {
                    case PROFILE_BOX_LIST.AGE_RANGE:
                        return this.memberInfo.age_range;
                    case PROFILE_BOX_LIST.HEIGHT:
                        return this.memberInfo[key] + 'cm';
                    case PROFILE_BOX_LIST.FOOT_WAY:
                        return this.transFootWay();
                    case PROFILE_BOX_LIST.SPECIAL_SKILL:
                        return this.memberInfo[key][this.specialSkillIndex];
                    case PROFILE_BOX_LIST.PLAY_STYLE:
                        return this.memberInfo[key][this.playStyleIndex];
                    case PROFILE_BOX_LIST.PLACE_NAME:
                        return this.setPlaceName(this.memberInfo[key]);
                    case PROFILE_BOX_LIST.USE_REASONS:
                        return this.memberInfo[key][this.useReasonsIndex];
                    case PROFILE_BOX_LIST.VISIT_REASONS:
                        return this.memberInfo[key];
                    case PROFILE_BOX_LIST.CAREER:
                        return this.transCareer(this.memberInfo.career, this.memberInfo.level);
                    default:
                        return '';
                }
            }
        },
        transRecommendCode() {
            if (this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().recommend_code) {
                if (this.mode === MY_VIEW_MODE.ME) {
                    return this.$GlobalStore.loginInfo().recommend_code
                } else {
                    return this.memberInfo.recommend_code
                }
            } else {
                return ''
            }
        },
        myImage() {
            return this.$GlobalStore.loginInfo().image_path
        }
    },
    methods: {
        setPlaceName(placeName) {
            if (this.isSecretProfile && this.mode != MY_VIEW_MODE.ME) {
                return '비공개'
            } else {
                return placeName
            }
        },
        goSoccerJoin() {
            this.$GlobalStore.closeModalAll()
            this.$router.push({ path: '/view/soccer_join?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        },
        showGrowthReport() {
            this.$GlobalStore.addModal('GrowthReport')
        },
        setPositionClass(gradeName) {
            if (gradeName === GRADE_NAME.BALL_BOY) {
                return 'ball_boy'
            } else if (gradeName === GRADE_NAME.RISING_STAR) {
                return 'rising_star'
            } else if (gradeName === GRADE_NAME.ACE) {
                return 'ace'
            } else {
                return 'world_class'
            }
        },
        setBackgroundColor(gradeName) {
            if (gradeName === GRADE_NAME.BALL_BOY) {
                return 'linear-gradient(134.38deg, #F2C1A0 0%, #D08A5B 49.93%, #B06A3A 74.44%, #D08A5B 86.69%, #D08A5B 98.94%)'
            } else if (gradeName === GRADE_NAME.RISING_STAR) {
                return 'linear-gradient(134.38deg, #E6E9EE 0%, #A9AFB9 49.47%, #A9AFB9 74.21%, #8A909B 86.57%, #8A909B 98.94%)'
            } else if (gradeName === GRADE_NAME.ACE) {
                return 'linear-gradient(134.38deg, #FFF8E1 0.92%, #FFD36A 13.18%, #E6B84A 25.43%, #C9971A 49.93%, #DB9D35 74.44%, #FFD36A 98.94%)'
            } else {
                return 'linear-gradient(134.38deg, #AF86FF 0%, #8860DE 19.79%, #7E5BBF 39.58%, #5A3B8E 59.36%, #3A225F 79.15%)'
            }
        },
        setShoesImg() {
            const transTotalPoint = parseInt(this.memberInfo.point)
            const gradeInfo = this.getGradeInfo(transTotalPoint)

            this.myGradeImagePath = gradeInfo.imagePath
            this.myGradeName = gradeInfo.gradeName
            this.nextPlayer = gradeInfo.nextPlayer
            this.remainPoint = gradeInfo.remainPoint
            this.remainPercent = gradeInfo.remainPercent
        },
        getGradeInfo(transTotalPoint) {
            let gradeIndex = 0     

            if (transTotalPoint >= 900) {
                gradeIndex = 3
            } else if (transTotalPoint >= 400) {
                gradeIndex = 2
            } else if (transTotalPoint >= 100) {
                gradeIndex = 1
            }

            const currentGrade = this.gradeList[gradeIndex]
            const nextGrade = this.gradeList[gradeIndex + 1] ?? currentGrade

            const nextMinPoint = parseInt(nextGrade.min_point)

            const remainPoint =
                gradeIndex < this.gradeList.length - 1
                    ? nextMinPoint - transTotalPoint
                    : 0

            const progressPercent =
                gradeIndex < this.gradeList.length - 1
                    ? Math.min((transTotalPoint / nextMinPoint) * 100, 100)
                    : 100

            return {
                gradeIndex,
                imagePath: currentGrade.image_path,
                gradeName: Object.values(GRADE_NAME)[gradeIndex],
                nextPlayer: nextGrade.name,
                remainPoint,
                remainPercent: progressPercent
            }
        },
        showCoachHistory() {
            this.isShowCoachHistoryPop = true
        },
        closeCoachHistoryPop() {
            this.isShowCoachHistoryPop = false
        },
        showCoachReport() {
            this.$GlobalStore.addModal('CoachingReport')
        },
        showMyReport() {
            this.$GlobalStore.addModal('ScoutingReport', { teamIdx: this.teamInfo.idx })
        },
        showNoTeam() {
            if (this.mode === MY_VIEW_MODE.ME) {
                this.isShowNoTeam = true
            }
        },
        showNotExpert() {
            if (this.mode === MY_VIEW_MODE.ME && this.memberInfo.is_coach == 0) {
                this.isShowNotExpert = true
            } else {
                this.showNoTeam()
            }
        },
        showNotExpertCoach() {
            if (this.mode === MY_VIEW_MODE.ME && this.memberInfo.is_coach == 0) {
                this.isShowNotExpert = true
            } else {
                if (!this.coachHistory) {
                    this.$GlobalStore.addModal('PersonalHistoryForm', { mode: 'insert', transitionName: '', isModalBackTransparent: true, completeAction: this.getMemberInfo })
                } else {
                    if (this.coachHistory.state == MEMBER_CAREER_HISTORY_STATE.REQUEST) {
                        this.isShowConfirmHistory = true
                    } else {
                        this.$GlobalStore.addModal('CoachingReport')
                    }
                }
            }
        },
        closeConfirmHistory() {
            this.isShowConfirmHistory = false
        },
        closeNoTeam() {
            this.isShowNoTeam = false
        },
        closeNotExpert() {
            this.isShowNotExpert = false
        },
        showRewardPage() {
            this.$GlobalStore.addModal('MembershipLevel')
        },
        beforeCloseAction() {
            if (!this.isMeCoach && this.isCoach) {
                const PROFILE_CLOSE_DATE = localStorage.getItem('PROFILE_CLOSE_DATE')
                const today = moment().format('YYYY-MM-DD');
                const isPassOneDay = today === PROFILE_CLOSE_DATE ? true : false

                if (!isPassOneDay) {
                    if (this.visitReasonType === VISIT_REASON_TYPE.LEARN_SOCCER) {
                        this.confirmMyTrainingVideo(true)
                    } else {
                        this.confirmMySoccerhow(true)
                    }
                    localStorage.setItem('PROFILE_CLOSE_DATE', today)
                } else {
                    this.$GlobalStore.closeLastModal()
                }
            } else {
                this.$GlobalStore.closeLastModal()
            }
        },
        showMyTrainingVideo() {
            this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_LEARN, isModalBackTransparent: true, isExpert: false, soccerhowIdx: this.selectedTrainingVideo.idx })
            this.closeTrainingVideoList()
        },
        hideProgressBar() {
            this.completeStep = 2
        },
        closeWriteForm() {
            this.isShowWriteForm = false
        },
        async getBannerList() {
            const res = await this.$Axios.get('/api/soccerhow/learn/banner')
            const bannerList = res.data.banner_list

            this.bannerList = bannerList
            this.refer_idx = this.bannerList[0].idx
        },
        async beforeCompleteAction() {
            const res = await this.$Axios.get('/api/soccerhow/mine/training_video')
            const trainingVideoList = res.data.soccerhows

            this.trainingVideoList = trainingVideoList
            this.selectedTrainingVideo = this.trainingVideoList[this.trainingVideoList.length - 1]

            this.isShowTrainingVideoList = true
            this.videoStep = 2
        },
        makeTrainingVideo() {
            this.$GlobalStore.addModal('UploadGuidePopup', {isModalBackTransparent : true, transitionName : '', completeAction : () => {
                    this.getBannerList()
                    this.isShowWriteForm = true
                }
            });
        },
        async sendTrainingVideo() {
            const formData = new FormData()
            formData.append('to_member_idx', this.memberInfo.idx)
            formData.append('from_member_idx', this.$GlobalStore.loginInfo().idx)
            formData.append('refer_idx', this.selectedTrainingVideo.idx)
            if (this.teamInfo) {
                formData.append('team_idx', this.teamInfo.idx)
            }
            formData.append('is_direct_feedback', false)

            const res = await this.$Axios.post('/api/direct_message/send/training_video', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.videoStep = 3
                setTimeout(() => {
                    this.isStart = true
                }, 500);
            }
        },
        nextStep() {
            if (Object.keys(this.selectedTrainingVideo).length === 0) {
                alert('피드백을 받고 싶은 영상을 선택해주세요')
                return
            }
            this.videoStep = 2
        },
        selectTrainingVideo(video) {
            if (video.idx === this.selectedTrainingVideo.idx && Object.keys(this.selectedTrainingVideo).length > 0) {
                this.selectedTrainingVideo = {}
            } else {
                this.selectedTrainingVideo = video
            }
        },
        closeTrainingVideoList() {
            this.selectedTrainingVideo = {}
            this.videoStep = 1
            this.completeStep = 1
            this.isShowTrainingVideoList = false
        },
        receiveFeedback() {
            this.isShowTrainingVideoList = true
        },
        closeTrainingVideoPoopup() {
            this.isShowTrainingVideoPopup = false
        },
        showPayForm() {
            this.$GlobalStore.addModal('RequestPayForm', { selectedTeam: this.teamInfo, soccerhowIdx: this.requestInfo.idx, isFromTeam: true })
        },
        closeRequestForm() {
            this.isShowRequestForm = false
        },
        async sendRequestForm() {
            const parameters = {};
            parameters.team_idx = this.teamInfo.idx
            const res = await this.$Axios.get('/api/soccerhow/reporting/target_team', { params: parameters });
            if (res.data.direct_message) {
                this.$GlobalStore.addModal('RequestReportDetail', { soccerhowIdx: res.data.direct_message.refer_idx })
            } else {
                this.isShowRequestForm = true
            }
        },
        showRequestJoinForm() {
            this.isShowRequestConfirmPopup = false;
            this.isShowMakeRequestJoinForm = true;
        },
        closeRequestConfirmPopup() {
            this.requestInfo = {}
            this.isShowRequestConfirmPopup = false
        },
        async confirmMyTrainingVideo(isCloseAction = false) {
            const res = await this.$Axios.get('/api/soccerhow/mine/training_video')
            const trainingVideoList = res.data.soccerhows
            this.trainingVideoList = trainingVideoList

            if (isCloseAction) {
                this.feedbackTitle = '보고 계신 전문가에게<br> 직접 피드백 받아보세요'
                if (this.trainingVideoList.length > 0) {
                    this.isExistTrainingVideo = true
                } else {
                    this.isExistTrainingVideo = false
                }
            } else {
                if (this.trainingVideoList.length > 0) {
                    this.feedbackTitle = '성장을 위한 첫걸음!<br>피드백 받을 영상을 선택해보세요'
                    this.isExistTrainingVideo = true
                } else {
                    this.feedbackTitle = '훈련 영상이 아직 없어요<br>지금 바로 직접 훈련 영상을 찍어봐요'
                    this.isExistTrainingVideo = false
                }
            }

            this.isShowTrainingVideoPopup = true
        },
        async confirmMySoccerhow(isCloseAction) {
            if (this.from_screen === SOCCER_HOW_TEAM_DETAIL_FROM_SCREEN.DEFAULT) {
                const parameters = {}
                const types = [SOCCER_HOW_TYPE.SC_COUNSEL, SOCCER_HOW_TYPE.SC_JOIN, SOCCER_HOW_TYPE.SC_JOB]
                parameters.types = types

                const res = await this.$Axios.get('/api/soccerhow/mine', { params: parameters })
                if (isCloseAction) {
                    this.requestTitle = '보고 계신 감독님에게<br>직접 입단 요청서를 보낼까요?'
                    if (res.data.soccerhows.length === 0) {
                        this.isExistSoccerhow = false
                    } else {
                        this.isExistSoccerhow = true
                        this.requestInfo = res.data.soccerhows[0]
                    }
                } else {
                    if (res.data.soccerhows.length === 0) {
                        this.requestTitle = '만들어둔 입단 요청서가 없어요<br>새로 만들어야 해요'
                        this.isExistSoccerhow = false
                    } else {
                        this.requestTitle = '보고 계신 감독님에게<br>직접 입단 요청서를 보낼까요?'
                        this.isExistSoccerhow = true
                        this.requestInfo = res.data.soccerhows[0]
                    }
                }
                this.isShowRequestConfirmPopup = true
            } else if (this.from_screen === SOCCER_HOW_TEAM_DETAIL_FROM_SCREEN.FROM_REQUEST_JOIN_TEAM_SELECTOR) {
                this.completeAction();
                this.$GlobalStore.closeLastModal();
            }
        },
        setSlideText() {
            this.$nextTick(() => {
                const wrapEls = this.$refs.text_wrap
                const textEls = this.$refs.text
            
                if (!wrapEls || !textEls) return
            
                // 기존 interval을 초기화 (중복 방지)
                if (this.intervals && this.intervals.length) {
                    this.intervals.forEach(interval => clearInterval(interval))
                }
                this.intervals = []
            
                wrapEls.forEach((elWrapper, index) => {
                    const el = textEls[index]
                    if (!el || !elWrapper) return
                
                    const containerWidth = elWrapper.clientWidth
                    const textWidth = el.clientWidth
                    const distance = textWidth - containerWidth
                    let isMoved = false
                
                    if (textWidth > containerWidth) {
                        const move = () => {
                            isMoved = !isMoved
                            el.style.transition = `transform ${moveDuration}ms linear`
                            el.style.transform = isMoved ? `translateX(-${distance}px)` : 'translateX(0)'
                        }

                        const baseSpeed = 4500
                        const speedPerPixel = 10

                        const moveDuration = Math.max(baseSpeed, distance * speedPerPixel)
                        const intervalDelay = moveDuration + 1000
                    
                    // 처음 한 번 즉시 실행
                        move()
                    
                        const interval = setInterval(move, intervalDelay)
                        this.intervals.push(interval)
                    }
                })
            })
        },
        showPositionResult() {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            if (this.memberInfo.idx === this.$GlobalStore.loginInfo().idx) {
                if (!this.memberInfo.position_pro_ability) {
                    this.$GlobalStore.addModal('FindPositionLite', { isShowDirectResult: true, memberPosition: this.memberInfo.position })
                    return
                } else {
                    this.showPositionProResult(PROFILE_BOX_LIST.POSITION)
                }
            }
        },
        setLike() {
            if (this.isShooting) {
                this.unlikeProfile()
            } else {
                this.saveFavoriteProfile()
            }
            this.isShooting = !this.isShooting
        },
        showMenu() {
            this.$GlobalStore.addModal('MenuService')
        },
        showSecretToggleAlert() {
            if (!this.isElitePlayer && !this.isSecretProfile) {
                this.$GlobalStore.addModal('ElitePlayerAuthAlert', {
                    isModalBackTransparent: true,
                    transitionName: '',
                    completeAction: () => {
                        setTimeout(() => {
                            this.isElitePlayer = true
                            this.changeSecretProfile(1)
                        }, 0)
                    }
                })
                return
            }
            if (this.isSecretProfile) {
                this.$GlobalStore.addModal('CommonAlertUi', {
                    theme: 'public',
                    title: '공개 프로필 전환',
                    contents: '프로필이 <span style="color:#FF7111">일반(공개)</span> 모드로 전환되어<br>게시물과 개인 정보가<br>다시 정상적으로 노출됩니다.',
                    cancelName: '취소',
                    okName: '전환하기',
                    okAction: () => {
                        setTimeout(() => {
                            this.changeSecretProfile(0)
                        }, 0)
                    },
                    isModalBackTransparent: true,
                    transitionName: '',
                })
            } else {
                this.$GlobalStore.addModal('CommonAlertUi', {
                    theme: 'secret',
                    title: '시크릿 프로필 전환',
                    contents: '프로필이 <span style="color:#9E4CF6">시크릿 모드</span>로 전환되어<br>게시물 내용과 일부 개인 정보가 타인에게 비공개 처리됩니다.',
                    cancelName: '취소',
                    okName: '전환하기',
                    okAction: () => {
                        setTimeout(() => {
                            this.changeSecretProfile(1)
                        }, 0)
                    },
                    isModalBackTransparent: true,
                    transitionName: '',
                })
            }
        },
        async changeSecretProfile(isSecret) {
            this.$GlobalStore.addModal('Loading', {
                transitionName: '',
                isModalBackTransparent: true,
                loadingText: isSecret == 1 ? '시크릿 프로필로 전환중' : '공개 프로필로 전환중'
            })
            const formData = new FormData()
            if (this.soccerHows.length > 0) {
                formData.append('soccerhow_idx', this.soccerHows[0].idx)
            }
            formData.append('is_secret', isSecret)
            const res = await this.$Axios.post('/api/soccerhow/request/secret/change', formData)
            this.$GlobalStore.closeLastModal()
            if (res.data.code === 0) {
                this.$set(this.memberInfo, 'is_secret', isSecret)
                this.soccerHows = this.soccerHows.map(each => ({
                    ...each,
                    is_secret: isSecret
                }))
                if (this.$GlobalStore.loginInfo()) {
                    this.$GlobalStore.loginInfo().is_secret = isSecret
                }
            } else if (res.data.msg) {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        async getFeedData() {
            this.isEnableNextPageHandle = false
            const types = SOCCER_HOW_TYPE.SC_COUNSEL + ',' + SOCCER_HOW_TYPE.SC_JOIN + ',' + SOCCER_HOW_TYPE.SC_JOB
            const parameters = {}
            parameters.page = this.page
            parameters.type = types
            parameters.sort = 'desc'
            parameters.is_except_exit_member = true;
            parameters.writer_idx = this.mode === MY_VIEW_MODE.OTHER ? this.memberIdx : this.memberInfo.idx
            parameters.writer_type = this.memberInfo.member_type

            const res = await this.$Axios.get('/api/soccerhow/list', { params: parameters })
            const soccerHows = res.data.soccerHows
            
            if (soccerHows.length > 0) {
                this.isEnableNextPageHandle = true
                if (this.page === 1) {
                    this.soccerHows = soccerHows
                } else {
                    this.soccerHows = [...this.soccerHows, ...soccerHows]
                }
            }
        }, 
        async getFeedDataGround() {
            this.isEnableNextPageHandle = false
            const types = SOCCER_HOW_TYPE.SINGLE_TRAINING + ',' + SOCCER_HOW_TYPE.GROUP_TRAINING
            const parameters = {}
            parameters.page = this.groundPage
            parameters.type = types
            parameters.sort = 'desc'
            parameters.is_except_exit_member = true;
            parameters.writer_idx = this.mode === MY_VIEW_MODE.OTHER ? this.memberIdx : this.memberInfo.idx
            parameters.writer_type = this.memberInfo.member_type

            const res = await this.$Axios.get('/api/soccerhow/list', { params: parameters })
            const soccerHows = res.data.soccerHows
            
            if (soccerHows.length > 0) {
                this.isEnableNextPageHandle = true
                if (this.groundPage === 1) {
                    this.soccerHowsGround = soccerHows
                } else {
                    this.soccerHowsGround = [...this.soccerHowsGround, ...soccerHows]
                }
            }
        },
        setBtnType(type) {
            this.btnType = type
            // this.soccerHows = []
            this.page = 1
            if (this.btnType === BTN_TYPE.REQUEST) {
                this.getFeedData()
            } else {
                this.getFeedDataGround()
            }
        },
        test(type) {
            const isMultiple = type === PROFILE_BOX_LIST.SPECIAL_SKILL ||
                type === PROFILE_BOX_LIST.USE_REASONS ||
                type === PROFILE_BOX_LIST.PLAY_STYLE;
            if (!isMultiple) return;

            const arr = this.memberInfo[type];
            if (!Array.isArray(arr) || arr.length === 0) return;

            if (type === PROFILE_BOX_LIST.SPECIAL_SKILL) {
                this.specialSkillIndex = (this.specialSkillIndex + 1) % arr.length;
            } else if (type === PROFILE_BOX_LIST.USE_REASONS) {
                this.useReasonsIndex = (this.useReasonsIndex + 1) % arr.length;
            } else if (type === PROFILE_BOX_LIST.PLAY_STYLE) {
                this.playStyleIndex = (this.playStyleIndex + 1) % arr.length;
            }
        },
        showTeamDetail(team_idx) {
            this.$GlobalStore.addModal('SoccerTeamDetail', { isModalBackTransparent: true, teamIdx: team_idx })
        },
        async sendDirectMessage() {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            if (!this.isCoach && this.$GlobalStore.loginInfo().is_temp_coach == 0) {
                this.showPersonalChat()
                return
            }
            this.$Util.showDirectMessageSenderForm({ memberInfo: this.memberInfo, isDirectUser: true });
        },
        async setServiceTab(type) {
            if (type.imagePathKey === MENU_LIST_KEY.NEWS) {
                this.$GlobalStore.addModal('SoccerhowRealTimeNews')
            } else if (type.imagePathKey === MENU_LIST_KEY.SPOTLIGHT) {
                this.$GlobalStore.addModal('SpotLightList')
            } else if (type.imagePathKey === MENU_LIST_KEY.INQUIRY) {
                this.$Util.showChatWithAdmin()
            } else if (type.imagePathKey === MENU_LIST_KEY.POSITION) {
                if (!this.$Util.checkProfileCompleteOrShowRequiredProfile()) return;
                this.$GlobalStore.addModal('SelectFindPosition')
                // this.$GlobalStore.addModal('FindPositionProMain', {});
            } else if (type.imagePathKey === MENU_LIST_KEY.WRITE && !this.isCoach) {
                this.$GlobalStore.addModal('MyPostList')
            } else if (type.imagePathKey === MENU_LIST_KEY.REQUEST) {
                this.getLastRequestReport();
            } else if (type.imagePathKey === MENU_LIST_KEY.WRITE) {
                this.$router.push({ path: '/view/mychat?time=' + new Date().getTime() + '&is_direct_message=true' });
            } else if (type.imagePathKey === MENU_LIST_KEY.MY_TEAM) {
                const res = await this.$Axios.get('/api/team/my');
                if (res.data.team) {
                    this.$GlobalStore.addModal('SoccerTeamDetail', { isModalBackTransparent: true, teamIdx: res.data.team.idx });
                } else {
                    this.$GlobalStore.showAlert('현재 지정된 팀이 없습니다.');
                }
            } else if (type.imagePathKey === MENU_LIST_KEY.TEAM_TRAINING) {
                this.$GlobalStore.addModal('TeamTrainingMng');
            } else if (type.imagePathKey === MENU_LIST_KEY.NOTICE) {
                this.$GlobalStore.addModal('Notification', { noticeType: NOTICE_TYPE.NOTICE })
            }
        },
        getLastRequestReport() {
            this.$GlobalStore.addModal('RequestReportList');
        },
        showActiveRank() {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            this.$GlobalStore.addModal('ActivityRanking')
        },
        toggleShape() {
            // 도형 전환
            this.isShape1 = !this.isShape1;
            if (this.isShape1) {
                this.currentPath = this.shape1Fill;
                this.currentPath2 = this.innerShape1;
                this.currentPathStroke = this.strokePath1
            } else {
                this.currentPath = this.shape2Fill;
                this.currentPath2 = this.innerShape2;
                this.currentPathStroke = this.strokePath2
            }
        },
        closeFriendPopup() {
            this.isFriend = false
            this.toggleShape()
        },
        touchStart() {
            if (!this.$GlobalStore.isLogin()) {
                return
            }
            if (!this.isShooting) {
                this.$refs.soccerBall.style.transform = 'rotate(-180deg)'
                this.$refs.soccerBall.style.transition = 'all 0.3s'
                this.$refs.soccerBall.style.left = '0px'
                this.$refs.ballWrapper.style.backgroundColor = '#da5800'
            }
        },
        touchEnd() {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            if (this.isShooting) {
                if (this.$refs.soccerBall) {
                    this.$refs.soccerBall.transition = ''
                    this.$refs.soccerBall.style.left = ''
                    this.$refs.soccerBall.style.transform = 'rotate(0)'
                }

                if (this.$refs.shoot) {
                    this.$refs.shoot.style.opacity = '0'
                }
            } else {
                if (this.$refs.soccerBall) {
                    this.$refs.soccerBall.style.transition = 'all 0.3s'
                    this.$refs.soccerBall.style.transform = 'rotate(0)'
                    this.$refs.soccerBall.style.left = '17px'
                }

                if (this.$refs.shoot) {
                    this.$refs.shoot.style.opacity = '1'
                    this.$refs.shoot.style.transition = 'all 0.3s'
                }

                if (this.$refs.ballWrapper) {
                    this.$refs.ballWrapper.style.backgroundColor = 'var(--color-main)'
                }
            }
            if (this.isShooting) {
                this.unlikeProfile()
            } else {
                this.saveFavoriteProfile()
            }
            this.isShooting = !this.isShooting
        },
        async unlikeProfile() {
            const formData = new FormData()
            formData.append('target_idx', this.memberInfo.idx)

            await this.$Axios.post('/api/like/member/delete', formData)
        },
        async saveFavoriteProfile() {
            const formData = new FormData()
            formData.append('target_idx', this.memberInfo.idx)

            const res = await this.$Axios.post('/api/like/member/save', formData)
            const isFriend = res.data.is_friend

            if (isFriend) {
                this.isFriend = true
                setTimeout(() => {
                    this.toggleShape()
                }, 1000)
            }
        },
        showFriendsList() {
            this.$GlobalStore.addModal('FriendsList', { member_idx: this.memberInfo.idx, mode: this.mode })
        },
        setIsAgeOrSex(isAgeOrSex) {
            if ((!this.memberInfo.age_range || !this.memberInfo.sex)) {
                return
            }
            if (this.disableToggle) {
                return
            }
            if (isAgeOrSex === PROFILE_BOX_LIST.AGE_RANGE) {
                this.isAgeOrSex = PROFILE_BOX_LIST.SEX
            } else {
                this.isAgeOrSex = PROFILE_BOX_LIST.AGE_RANGE
            }
        },
        setIsHeightOrFootWay(isHeightOrFootWay) {
            if (!this.memberInfo.height || !this.memberInfo.foot_way) {
                return
            }
            if (isHeightOrFootWay === PROFILE_BOX_LIST.HEIGHT) {
                this.isHeightOrFootWay = PROFILE_BOX_LIST.FOOT_WAY
            } else {
                this.isHeightOrFootWay = PROFILE_BOX_LIST.HEIGHT
            }
        },
        showPositionProResult(type) {
            if (this.$GlobalStore.loginInfo().idx != this.memberInfo.idx) {
                return
            }

            if (this.$GlobalStore.loginInfo().idx == this.memberInfo.idx) {
                if (!this.memberInfo.position_pro_ability) {
                    return
                }
            }

            if (type !== PROFILE_BOX_LIST.POSITION) {
                return
            }

            const ability_arr = this.memberInfo.position_pro_ability.split(',');

            const groupData = {
                [FIND_POSITION_PRO_TITLE.HEALTH]: ability_arr[0],
                [FIND_POSITION_PRO_TITLE.EYESIGHT]: ability_arr[1],
                [FIND_POSITION_PRO_TITLE.MAIN_FORCE]: ability_arr[2],
                [FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT]: ability_arr[3],
                [FIND_POSITION_PRO_TITLE.BALL_CONTROL]: ability_arr[4],
            };
            const myPositions = [
                { desc: this.myPositions.desc, position: this.myPositions.position }
            ]
            this.$GlobalStore.addModal('FindPositionProResult', { positionsArr: myPositions, showGraph: false, groupedData: groupData, isConfirmDirectClose: true, isFromProfile: true })
        },
        async showPersonalChat() {
            await this.$Axios.showPersonalChat(this.memberInfo.idx, this.memberInfo.member_type, JOIN_CHAT_TYPE.SINGLE);
        },
        closeInviteScheduleModal() {
            this.isOpenInviteScheduleModal = false
        },
        getFootImage() {
            if (this.memberInfo.foot_way == PROFILE_FOOT_WAY.BOTH) {
                return require('@/assets/images/mypage/profile_box_foot_way_both.svg')
            } else if (this.memberInfo.foot_way == PROFILE_FOOT_WAY.LEFT) {
                return require('@/assets/images/mypage/profile_box_foot_way.svg')
            } else {
                return require('@/assets/images/mypage/profile_box_foot_way_right.svg')
            }
        },
        transDate(date) {
            if (date.split(' ')[0] === this.today) {
                return ''
            } else {
                const transDate = this.$Util.getMMDDDayHangulStr(date).split(' ')
                transDate.splice(0, 1)

                return transDate.join(' ')
            }

        },
        handleNextPage() {
            if (!this.isCoach && this.btnType === BTN_TYPE.REQUEST) {
                this.page++
                this.getFeedData()
            } else if (!this.isCoach && this.btnType === BTN_TYPE.GROUND) {
                this.groundPage++
                this.getFeedDataGround()
            }
        },
        async getEnterFeed() {
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.page = this.page
            parameters.member_idx = this.copyMemberIdx
            parameters.member_type = this.memberInfo.member_type

            if (this.selectFeed !== 'all' && !this.selectDetailFeed) {
                parameters.feed_type = this.selectFeed
            } else if (this.selectDetailFeed) {
                parameters.feed_type = this.selectDetailFeed
            }

            const res = await this.$Axios.get('/api/my/feed/joined', { params: parameters })

            const result = res.data.feeds

            if (result.length > 0) {
                this.isEnableNextPageHandle = true
                this.myFeedList = [...this.myFeedList, ...result]
            }
        },
        closeScheduleDetail() {
            this.isOpenScheduleDetail = false
        },
        async getMyFeed() {
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.page = this.page
            parameters.member_idx = this.copyMemberIdx
            parameters.member_type = this.memberInfo.member_type

            const res = await this.$Axios.get('/api/my/feed', { params: parameters })

            const result = res.data.feeds

            if (result.length > 0) {
                this.isEnableNextPageHandle = true;
                this.myFeedList = [...this.myFeedList, ...result]
            }
        },
        showSettings() {
            this.$GlobalStore.addModal('ActivityAndSettings', { completeAction: this.getMemberInfo })
        },
        setIsOpenSettings(name, isClose = false, isComplete, isSave) {
            if (isComplete) {
                return
            }
            if (name === PROFILE_BOX_LIST.POSITION) {
                if (!this.$Util.checkProfileCompleteOrShowRequiredProfile()) return;
                // this.$GlobalStore.addModal('FindPositionProMain', {});
                this.$GlobalStore.addModal('SelectFindPosition')
                return
            }
            const setting = this.settingsArray.find(item => item.name === name);
            if (setting) {
                const key = Object.keys(setting).find(key => key.startsWith('isOpenSetting'));
                if (key) {
                    if (isClose) {
                        setting[key] = false;
                    } else {
                        setting[key] = true;
                    }
                }
            }
            if (isSave) {
                this.getMemberInfo(isSave)
            }
        },
        setFeedList(selectFeed, feedName) {
            this.$set(this.feedList, 1, { name: feedName, key: 'feed_category', uniqueKey: true })
            this.selectFeed = "feed_category"
            this.selectDetailFeed = selectFeed
            this.page = 1
            this.myFeedList = []
            this.getEnterFeed()
            this.isShowPopupMenu = false
        },
        setIsShowPopupMenu() {
            this.isShowPopupMenu = true

            this.menuOptions = {
                labelAndAction: [
                    { label: '하우 피드', action: () => { this.setFeedList('soccerhow', '하우 피드') } },
                    { label: '스케줄 피드', action: () => { this.setFeedList('schedule', '스케줄 피드') } },
                    { label: '멤버톡 피드', action: () => { this.setFeedList('membertalk', '멤버톡 피드') } },
                ],
                isExistCancelBtn: true,
                closeAction: () => {
                    console.log('취소');
                    this.isShowPopupMenu = false;
                }
            }
        },
        showProfileEdit() {
            this.$GlobalStore.addModal('MyProfileEdit', { memberIdx: this.$GlobalStore.loginInfo().idx, completeAction: this.getMemberInfo })
        },
        async logout() {
            this.$GlobalStore.showConfirm('<strong style="color: #101014; margin-bottom: 6px; display: inline-block;">로그아웃</strong><br>잠시 로그아웃할까요?<br>언제든 다시 로그인할 수 있어요.', async () => {
                this.$Util.sendEventClick('마이_로그인보안_로그아웃')
                const res = await this.$Axios.post('/api/logout');
                if (res.data.code === 0) {
                    location.href = initialRouteStr;
                } else {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }, '로그아웃', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION2)
        },
        setMultipleBox() {
            this.memberInfo.special_skill = !this.memberInfo.special_skill ? null : this.memberInfo.special_skill.split(',');
            this.memberInfo.use_reasons = !this.memberInfo.use_reasons ? null : this.memberInfo.use_reasons.split(',');
            this.memberInfo.playstyle = !this.memberInfo.playstyle ? null : this.memberInfo.playstyle.split(',');
            // this.memberInfo.playstyle = null

            if (this.memberInfo.special_skill) {
                this.multipleBox.push(this.memberInfo.special_skill)
            } else {
                this.multipleBox.push([])
            }
            if (this.memberInfo.use_reasons) {
                this.multipleBox.push(this.memberInfo.use_reasons)
            } else {
                this.multipleBox.push([])
            }
            if (this.memberInfo.playstyle) {
                this.multipleBox.push(this.memberInfo.playstyle)
            } else {
                this.multipleBox.push([])
            }
        },
        setTrainingAmount() {
            const dayMap = ['일', '월', '화', '수', '목', '금', '토'];

            this.trainingDate.forEach(item => (item.count = 0));

            // insert_date 기준으로 요일별 count 증가
            this.trainingAmount.forEach(item => {
                const date = new Date(item.insert_date);
                const dayName = dayMap[date.getDay()]; // ex) '월'
                
                const target = this.trainingDate.find(d => d.day === dayName);
                if (target) {
                    target.count += 1;
                }
            });
        },
        async getMemberInfo(isSave) {
            if (isSave) {
                this.profileBoxList = []
                this.disableToggle = false
            }
            const parameters = {};
            this.completeCount = 0
            parameters.memberIdx = this.copyMemberIdx;
            if (this.mode === MY_VIEW_MODE.OTHER) {
                parameters.is_visit = true
            }
            const res = await this.$Axios.get('/api/member/profile', { params: parameters });
            if (res.data.code === ResponseCode.NOT_EXIST_DATA) {
                this.$GlobalStore.showAlert('회원정보를 찾을 수 없습니다.');
                this.$GlobalStore.closeLastModal();
                return;
            }

            if (res.data.code === ResponseCode.PROFILE_HIDDEN) {
                this.$Util.showRejectProfilePopup()
                return
            }

            if (res.data.is_deleted) {
                this.$GlobalStore.showToastVer2('탈퇴한 회원입니다.')
                this.$GlobalStore.closeLastModal()
                return
            }

            const memberInfo = res.data.member
            this.isElitePlayer = memberInfo.is_elite_player == 1 ? true : false
            const teamInfo = res.data.team
            const month_period_view_cnt = res.data.month_period_view_cnt
            const coach_history = res.data.coach_history
            // const memberPlaceInfo = res.data.memberPlace
            const memberStats = res.data.memberStats
            const favorite_member_cnt = res.data.favorite_member_cnt
            const grade_list = res.data.grade_list

            this.media = res.data.media;
            this.teamInfo = teamInfo
            this.coachHistory = coach_history
            this.memberInfo = memberInfo;
            if (this.memberInfo) {
                this.$set(this.memberInfo, 'is_secret', this.memberInfo.is_secret == 1 ? 1 : 0)
            }
            this.gradeList = grade_list;
            this.total_view_cnt = res.data.total_view_cnt
            this.scout_cnt = res.data.user_scout_cnt
            this.training_cnt = res.data.training_cnt
            this.memberStats = memberStats
            this.favorite_member_cnt = favorite_member_cnt
            this.trainingAmount = res.data.training_amount
            if (this.coachHistory) {
                this.coachPeriod = JSON.parse(this.coachHistory.coach_period)
                this.playerPeriod = JSON.parse(this.coachHistory.player_period)
            }
            if (!this.isCoach) {
                this.setTrainingAmount()
                this.setShoesImg()
            }

            // 테스트용
            if (this.isCoach) {
                this.memberInfo.rate_plan = 'lite'
                this.memberInfo.trade_scout = 2
                this.memberInfo.ground_scout = 4
            }
            console.log(this.memberInfo)
            // 
            if (this.memberInfo.age_range_show == 0 && this.memberInfo.sex_show == 1) {
                this.setIsAgeOrSex(PROFILE_BOX_LIST.AGE_RANGE)
            } else {
                this.setIsAgeOrSex(PROFILE_FOOT_WAY.SEX)
            }
            if (this.memberInfo.age_range_show == 0 || this.memberInfo.sex_show == 0) {
                this.disableToggle = true
            } else {
                this.disableToggle = false
            }
            if (!this.isCoach) {
                this.setMultipleBox()
            }
            this.month_period_view_cnt = month_period_view_cnt

            // 테스트용 나중에 지워야됨
            // this.memberInfo.license = null
            // this.memberInfo.age_range = null
            // 테스트용 나중에 지워야됨
            this.isShooting = res.data.is_liked
            if (!this.memberInfo.age_range) {
                this.isAgeOrSex = PROFILE_BOX_LIST.SEX
            }

            // if (this.isPopup) {
            //     this.$nextTick(() => {
            //         const imageUrl = this.$resourcePath + this.memberInfo.image_path
            //         this.$refs.background_image.style.backgroundImage = `url('${imageUrl}')`;
            //     })
            // }
            if (this.isCoach) {
                this.setProfileBoxCoach()
            } else {
                this.setProfileBoxCommon()
            }
            this.isComplete = true
            this.showContents = true
            if (this.isShooting && this.isPopup) {
                this.$nextTick(() => {
                    if (this.$refs.soccerBall) {
                        this.$refs.soccerBall.style.transition = 'all 0.3s'
                        this.$refs.soccerBall.style.transform = 'rotate(0)'
                        this.$refs.soccerBall.style.left = '17px'
                    }

                    if (this.$refs.shoot) {
                        this.$refs.shoot.style.opacity = '1'
                        this.$refs.shoot.style.transition = 'all 0.3s'
                    }

                    if (this.$refs.ballWrapper) {
                        this.$refs.ballWrapper.style.backgroundColor = 'var(--color-main)'
                    }
                })
            }

            this.$set(this.myPositions, 'desc', this.memberInfo.position)
            this.$set(this.myPositions, 'position', this.memberInfo.position)
            if (!this.isCoach) {
                this.getFeedData()
                this.getFeedDataGround()
            }
            // this.setSlideText()
        },
        setProfileBoxCoach() {
            this.myProfileBoxList = [
                { name: PROFILE_BOX_LIST.POSITION, isComplete: false },
                { name: PROFILE_BOX_LIST.USE_REASONS, isComplete: false },
                { name: PROFILE_BOX_LIST.LICENSE, isComplete: false },
            ]

            this.checkProfileBoxList = [
                PROFILE_BOX_LIST.LICENSE,
                PROFILE_BOX_LIST.PLACE_NAME,
                PROFILE_BOX_LIST.POSITION,
                PROFILE_BOX_LIST.USE_REASONS,
            ]
            this.completeCount = 3
            this.isCompleteProfileBox = this.$Util.isCompleteProfileBox(this.memberInfo, true)
            if (this.mode === MY_VIEW_MODE.ME && !this.isCompleteProfileBox) {
                for (const key in this.myProfileBoxList) {
                    if (this.memberInfo[this.myProfileBoxList[key].name] !== null) {
                        this.myProfileBoxList[key].isComplete = true
                        this.completeCount++
                    }
                }
            }
            this.profileBoxList.push('star')
            for (const key of this.checkProfileBoxList) {
                if (this.memberInfo[key] !== null) {
                    this.profileBoxList.push(key)
                }
            }
        },
        setProfileBoxCommon() {
            this.myProfileBoxList = [
                { name: PROFILE_BOX_LIST.PLACE_NAME, isComplete: false },
                { name: PROFILE_BOX_LIST.POSITION, isComplete: false },
                { name: PROFILE_BOX_LIST.VISIT_REASONS, isComplete: false },
                { name: PROFILE_BOX_LIST.USE_REASONS, isComplete: false },
                { name: PROFILE_BOX_LIST.HEIGHT, isComplete: false },
                { name: PROFILE_BOX_LIST.FOOT_WAY, isComplete: false },
                { name: PROFILE_BOX_LIST.SPECIAL_SKILL, isComplete: false },
                { name: PROFILE_BOX_LIST.PLAY_STYLE, isComplete: false },
            ]

            this.checkProfileBoxList = [
                PROFILE_BOX_LIST.POSITION,
                PROFILE_BOX_LIST.AGE_RANGE,
                PROFILE_BOX_LIST.HEIGHT,
                PROFILE_BOX_LIST.FOOT_WAY,
                PROFILE_BOX_LIST.PLACE_NAME,
                PROFILE_BOX_LIST.VISIT_REASONS,
                PROFILE_BOX_LIST.USE_REASONS,
                PROFILE_BOX_LIST.PLAY_STYLE,
                PROFILE_BOX_LIST.SPECIAL_SKILL,
                PROFILE_BOX_LIST.CAREER
            ]

            this.isCompleteProfileBox = this.$Util.isCompleteProfileBox(this.memberInfo, false)
            if (this.mode === MY_VIEW_MODE.ME && !this.isCompleteProfileBox) {
                for (const key in this.myProfileBoxList) {
                    if (this.memberInfo[this.myProfileBoxList[key].name] !== null) {
                        this.myProfileBoxList[key].isComplete = true
                        this.completeCount++
                    }
                }
            }
            for (const key of this.checkProfileBoxList) {
                if (this.memberInfo[key] !== null && key !== PROFILE_BOX_LIST.POSITION && key !== PROFILE_BOX_LIST.HEIGHT && key !== PROFILE_BOX_LIST.AGE_RANGE && key !== PROFILE_BOX_LIST.FOOT_WAY) {
                    this.profileBoxList.push(key)
                }
            }
            if (!this.memberInfo.height && this.memberInfo.foot_way) {
                this.isHeightOrFootWay = PROFILE_BOX_LIST.FOOT_WAY
            } else if (this.memberInfo.height && this.memberInfo.foot_way) {
                this.isHeightOrFootWay = PROFILE_BOX_LIST.HEIGHT
            }
        },
        transTextName(key) {
            switch (key) {
                case PROFILE_BOX_LIST.POSITION:
                    return '포지션';
                case PROFILE_BOX_LIST.HEIGHT:
                    return '키';
                case PROFILE_BOX_LIST.FOOT_WAY:
                    return '사용하는 발';
                case PROFILE_BOX_LIST.SPECIAL_SKILL:
                    return '개인기';
                case PROFILE_BOX_LIST.PLAY_STYLE:
                    return '플레이 스타일';
                case PROFILE_BOX_LIST.PLACE_NAME:
                    return '활동지역';
                case PROFILE_BOX_LIST.USE_REASONS:
                    return '관심사';
                case PROFILE_BOX_LIST.VISIT_REASONS:
                    return '이용 목적';
                case PROFILE_BOX_LIST.LICENSE:
                    return '지도자 등급'
                default:
                    break;
            }
        },
        transTextCoach(key) {
            switch (key) {
                case 'star':
                    return this.memberInfo.coach_type
                case PROFILE_BOX_LIST.LICENSE:
                    return this.memberInfo.licenses
                case PROFILE_BOX_LIST.POSITION:
                    return this.memberInfo.position
                case PROFILE_BOX_LIST.PLACE_NAME:
                    return this.memberInfo[key];
                case PROFILE_BOX_LIST.USE_REASONS:
                    return this.memberInfo[key];
                default:
                    break;
            }
        },
        transCareer(career, level) {
            const result = level + ' / ' + career
            return result
        },
        transContents(key) {
            switch (key) {
                case PROFILE_BOX_LIST.POSITION:
                    return '포지션 찾기를 진행해서 포지션을 설정할 수 있습니다.';
                case PROFILE_BOX_LIST.HEIGHT:
                    return '다른 회원들에게 피지컬 정보를 제공할 수 있습니다.';
                case PROFILE_BOX_LIST.FOOT_WAY:
                    return '회원님이 자주 사용하는 발을 선택할 수 있습니다.';
                case PROFILE_BOX_LIST.SPECIAL_SKILL:
                    return '회원님이 가장 잘하는 개인기를 알릴 수 있습니다.';
                case PROFILE_BOX_LIST.PLAY_STYLE:
                    return '회원님의 플레이 스타일을 알릴 수 있습니다.';
                case PROFILE_BOX_LIST.PLACE_NAME:
                    return '같은 지역 사람들을 볼 수 있는 가장 중요한 정보입니다.';
                case PROFILE_BOX_LIST.USE_REASONS:
                    return '축구화, 해외축구, K리그 등 관심있는 분야가 있나요?';
                case PROFILE_BOX_LIST.DISPLAY_TAG:
                    return '관심사를 설정하여 맞춤형 피드를 추천받아볼 수 있습니다.';
                case PROFILE_BOX_LIST.LICENSE:
                    return '보유하고 있는 지도자 라이선스가 있나요?'
                default:
                    break;
            }
        },
        transFootWay() {
            if (this.memberInfo.foot_way == PROFILE_FOOT_WAY.BOTH) {
                return '양발'
            } else if (this.memberInfo.foot_way == PROFILE_FOOT_WAY.LEFT) {
                return '왼발'
            } else {
                return '오른발'
            }
        },
        async getMineRanking() {
            const parameters = {};
            parameters.member_idx = this.memberIdx;
            const res = await this.$Axios.get('/api/member/step/target_ranking', { params: parameters });
            this.mine_ranking = res.data.mine_ranking
        }
    },
    deactivated() {
        if (this.intervals && this.intervals.length) {
            this.intervals.forEach(interval => clearInterval(interval))
            this.intervals = []
        }
    },
    created() {
        this.unlikeProfile = this.$Once(this.unlikeProfile)
        this.saveFavoriteProfile = this.$Once(this.saveFavoriteProfile)
        this.logout = this.$Once(this.logout)
        setTimeout(() => {
            this.getMemberInfo();
            this.isShowBackGroundImage = true;
        }, 500);

        if (this.mode === MY_VIEW_MODE.OTHER) {
            this.getMineRanking();
        }
        console.log(this.$GlobalStore.loginInfo())

        // await this.getMyFeed()
    }
}
</script>

<style scoped>
.gradient_border {
    border: 2px solid transparent;
    border-radius: 12px;
    padding: 12px;
    background:
        linear-gradient(#fff, #fff) padding-box,
        linear-gradient(269.1deg, #FF7111 2.07%, #FFB700 96.64%) border-box;
}

.inner_circle {
    background-color: #f1f2f5;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
}

.inner_circle_secret {
    background-color: #7c7979;
}

.inner_circle_coach {
    background-color: #f1f2f5;
    width: 62px;
    height: 62px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
}
    
.ball_boy {
    background: #E0E0E033;
    border: 1px solid #b97444;
}

.rising_star {
    background: #E0E0E033;
    border: 1px solid #aaafb9
}

.ace {
    background: #E0E0E033;
    border: 1px solid #d69b2e;
}

.world_class {
    background: #E0E0E033;
    border: 1px solid #69489d;
}

.next_btn {
    height: 56px; 
    width: 286px; 
    margin: 0 auto; 
    margin-bottom: 40px; 
    display: flex; 
    justify-content: center; 
    align-items: center; 
    border-radius: 40px; 
    font-size: 14px; 
    font-weight: 700; 
    margin-top: 40px;
}

.next_btn.btn_active {
    background-color: #210f03; 
    color: var(--color-main); 
}

.next_btn.btn_un_active {
    background-color: #d9d9d9;
    color: #bbbbbb;
}

path {
    transition: all 0.5s ease;
}

@keyframes moveUpRight {
    from {
        transform: translate(-100%, 100%);
    }

    to {
        transform: translate(100vw, -70vh);
    }
}

.coach_class {
    width: 177px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    height: 60px;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 700;
    background: linear-gradient(90deg, #FF7111 0%, #EABB56 50%, #FFC39A 100%);
}

.secret_box {
    background: linear-gradient(138.33deg, #F6EEFF 1.41%, #FED9FF 99.02%);
    border-radius: 12px;
    padding: 12px;
}

.request_box {
    background: linear-gradient(99.38deg, #FFF6EA 1.08%, #FCF0F6 99.35%);
    border-radius: 12px;
    padding: 12px;
}

.secret_box_other {
    background-color: #15171D;
    border-radius: 20px;
    padding: 28px 24px;
}

.blur_box {
    filter: blur(4px);
    -webkit-filter: blur(4px);
}

.training_box {
    background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%);
    border-radius: 12px;
    padding: 12px;
}

.move-up-right {
    animation: moveUpRight 1s ease-out forwards;
}

.background_image_wrapper {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    z-index: -1;
    opacity: 0.2;
    filter: blur(100px);
}

.popup_style {
    background-color: #fff
}

.pro_background {
    background: linear-gradient(180deg, #1370AF 0%, #210F03 31.66%);
}

.pro_nicname {
    color: #fff;
}

.pro_color {
    background: linear-gradient(180deg, #466091 -70.83%, #6D7481 65.25%, #485263 87.44%, #3E3E3E 225%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    font-weight: 700;
}

.lite_color {
    color: #606060
}

.lite_background_btn {
    background-color: #f5f5f5;
    border-radius: 12px;
    width: 182px;
    padding: 12px 0;
    text-align: center;
    border: 2px solid #00000033;
    font-size: 14px;
    font-weight: 700;
}

.pro_background_btn {
    background-color: #fff;
}

.profile_box {
    width: 70px;
    display: flex;
    align-items: center;
    position: relative;
    flex-direction: column;
    gap: 5px;
    justify-content: space-between;
}

.profile_box_coach {
    display: flex;
    align-items: center;
    position: relative;
    flex-direction: column;
    gap: 5px;
    justify-content: space-between;
}

.profile_box_lite {
    background: linear-gradient(90deg, #F5F5F5 49.91%, #EBEBEB 100%);
}

.profile_box_pro {
    background: linear-gradient(180deg, #1370AF 0%, #210F03 31.66%);
    color: #fff;
}

.need_grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px 12px;
    /* place-items: center; */
    justify-items: center;
}

.need_grid_coach {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 25px 12px;
    justify-items: center;
}

.no_grid {
    width: 110px;
    margin: 0 auto;
}

.my_profile_box {
    min-width: 160px;
    max-width: 160px;
    height: 165px;
    padding: 12px 18px;
    background-color: #f5f5f5;
    border-radius: 12px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

.un_active {
    color: #bbb;
}

.active {
    color: #210f03;
}

.active-secret {
    color: #fff;
}

.common_btn {
    margin-top: 30px;
    height: 48px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    width: 100%;
}

.empty_circle {
    width: 47px;
    height: 47px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ebebeb;
    gap: 6px;
}

.white_circle {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #fff;
}

.empty_title {
    font-weight: 700;
    margin-top: 20px;
    line-height: 24px;
}

.secret_toggle {
    position: relative;
    display: flex;
    align-items: center;
    width: 100px;
    height: 36px;
    padding: 5px;
    border-radius: 999px;
    background: #FF7111;
    box-sizing: border-box;
}

.secret_toggle.is_secret {
    background: #9E4CF6;
}

.secret_toggle_label {
    position: relative;
    z-index: 1;
    flex: 1;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    text-align: center;
    padding-right: 45px;
    box-sizing: border-box;
}

.secret_toggle.is_secret .secret_toggle_label {
    padding-right: 0;
    padding-left: 45px;
}

.secret_toggle_knob {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 45px;
    height: 26px;
    border-radius: 999px;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16);
    transition: left 0.2s ease, right 0.2s ease;
}

.secret_toggle.is_secret .secret_toggle_knob {
    left: 5px;
    right: auto;
}
</style>